<template>
  <div class="standalone-header">
    <div class="standalone-logo">
      <img v-if="imageLink != ''" src="{{imageLink}}" alt="" />
      <!--<img v-if="imageLink == '' || imageLink == null" src="../../../assets/css/images/default-logo.png"
          style="background-color: black;" />-->
    </div>
    <div class="standalone-dealer">
      {{ dealerName }}
    </div>
  </div>

  <form autocomplete="off" v-if="showAddSendTLoanHomiForm" class="standalone-page-container">
    <div class="accordion" id="accordionSystemInfo">
      <div class="accordion-item border-dark">
        <h2 class="accordion-header" id="headingSystemInfo">
          <button class="accordion-button bg-secondary text-white" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSystemInfo" aria-expanded="true" aria-controls="collapseSystemInfo">
            <span>{{ $t('CRMSetting.SystemInfo') }}:</span>
          </button>
        </h2>
        <div id="collapseSystemInfo" class="all_custom_fields accordion-collapse show" aria-labelledby="headingSystemInfo"
          data-bs-parent="#accordionSystemInfo">
          <div class="accordion-body">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.LoanProduct') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.LoanProductId" :options="loanProductList" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectLoanProduct')" class="w-full md:w-14rem"
                      @change="onChangeLoanProduct(addSendTLoanHomiForm.LoanProductId)" @clear="onClear('ddlOption')"
                      :class="{
                        'is-invalid':
                          v$.LoanProductId.$invalid && v$.LoanProductId.$dirty,
                      }" />

                    <small v-if="v$.LoanProductId.$invalid && v$.LoanProductId.$dirty" class="text-danger">{{
                      $t('CRMSetting.LoanProductIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.Term') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.term" maxlength="50" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.Street') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.street" maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.City') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.city" maxlength="50" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.Country') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.country" :options="countryLists" showClear optionLabel="text"
                      optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.SelectCountry')"
                      class="w-full md:w-14rem" @change="onCountryChange(addSendTLoanHomiForm.country, 'first')"
                      @clear="onClear(addSendTLoanHomiForm.country, 'first')" />
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.State') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.state" :options="states" showClear optionLabel="text"
                      optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.SelectState')"
                      class="w-full md:w-14rem" :class="{
                        'is-invalid':
                          v$.LoanProductId.$invalid && v$.LoanProductId.$dirty,
                      }" />
                    <small v-if="v$.state.$invalid && v$.state.$dirty" class="text-danger">{{
                      $t('CRMSetting.StateIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.ZipCode') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.postalCode" maxlength="50" />
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.TotalAmount') }}:</label> <span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="text" class="form-control" v-model="addSendTLoanHomiForm.totalSystemCost"
                          @input="totalSystemCost(addSendTLoanHomiForm.totalSystemCost)"
                          @focusout="removeSpecialCharacters($event)" appTwoDigitDecimaNumberDirective maxlength="50"
                          :class="{
                            'is-invalid':
                              v$.totalSystemCost.$invalid && v$.totalSystemCost.$dirty,
                          }" />
                      </div>
                      <small v-if="v$.totalSystemCost.$invalid && v$.totalSystemCost.$dirty" class="text-danger">
                        {{ $t('CRMSetting.PleaseEnterTheTotalLoanAmount') }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.DownpaymentAmount') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="text" class="form-control" v-model="addSendTLoanHomiForm.downpaymentAmount" @input="
                          downpaymentAmount(addSendTLoanHomiForm.downpaymentAmount)
                          " @focusout="removeSpecialCharactersDownpaymentAmount($event)"
                          appTwoDigitDecimaNumberDirective maxlength="50" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.LoanAmount') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.loanAmount" maxlength="50"
                          disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4"><label>{{ $t('CRMSetting.OwnTheProperty') }}:</label></div>
                  <div class="col-md-12 col-lg-8">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.ownthePropertyID" :options="lstowntheProperty" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectProperty')" class="w-full md:w-14rem" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.NoOfMortgages') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.noOfMortgages"
                      @input="no_Mortgages(addSendTLoanHomiForm.noOfMortgages)" maxlength="2"
                      @keypress="keyPressNo($event)" :class="{
                        'is-invalid':
                          v$.noOfMortgages.$invalid && v$.noOfMortgages.$dirty,
                      }" />
                    <small v-if="v$.noOfMortgages.$invalid && v$.noOfMortgages.$dirty" class="text-danger">
                      {{ $t('CRMSetting.NoOfMortgagesIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.SalesRepName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.installerRepNameId" :options="installerRepNameList" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectSalesRepName')" class="w-full md:w-14rem" :class="{
                        'is-invalid':
                          v$.installerRepNameId.$invalid && v$.installerRepNameId.$dirty,
                      }" />

                    <small v-if="v$.installerRepNameId.$invalid && v$.installerRepNameId.$dirty
                      " class="text-danger">{{ $t('CRMSetting.SalesRepNameIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-4">
                    <label>{{ $t('CRMSetting.Agreement') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-8">
                    <div class="input-group">
                      <div class="custom-file w-100">
                        <input class="custom-file-input form-control" type="file" name="file" ref="fileInput"
                          :accept="fileExtension" @change="allowPDF($event)" lang="es" />
                        <label class="custom-file-label" v-if="fileName != 'Install Agreement'">{{ fileName }}</label>
                        <label class="custom-file-label" v-if="fileName == 'Install Agreement'">{{
                          $t('CRMSetting.UploadAgreement') }}</label>
                      </div>
                      <button class="input-group-text bg-white border-0 p-0" @click="clearSelectedpdf(fileInput)" style="
                          position: absolute;
                          z-index: 10;
                          right: 73px;
                          padding: 10px 6px !important;
                          color: #d00b05 !important;
                          top: 1px;
                          cursor: pointer;
                        ">
                        <i class="feather-repeat"></i>
                      </button>
                      <small><i class="text-primary">{{ $t('CRMSetting.ValidFileFormatIs') }} {{ fileExtension }} {{
                        $t('CRMSetting.AndlimitUpto') }}
                          {{ fileSize }}MB.</i>
                      </small>
                      <div class="w-100">
                        <small v-if="v$.fileInputValue.$invalid && v$.fileInputValue.$dirty" class="text-danger">
                          {{ $t('CRMSetting.FileIsRequired') }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--================================================== Applicant Detail:   =====================================================================-->

    <div class="accordion" id="accordionApplicant" style="margin-top: 15px">
      <div class="accordion-item border-dark">
        <h2 class="accordion-header" id="headingApplicant">
          <button class="accordion-button bg-secondary text-white" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseApplicant" aria-expanded="true" aria-controls="collapseApplicant">
            <span>{{ $t('CRMSetting.ApplicantDetail') }}:</span>
          </button>
        </h2>
        <div id="collapseApplicant" class="all_custom_fields accordion-collapse show" aria-labelledby="headingApplicant"
          data-bs-parent="#accordionApplicant">
          <div class="accordion-body">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.FirstName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.firstName" maxlength="50"
                      :class="{
                        'is-invalid': v$.firstName.$invalid && v$.firstName.$dirty,
                      }" />
                    <small v-if="v$.firstName.$invalid && v$.firstName.$dirty" class="text-danger">
                      {{ $t('CRMSetting.FirstNameIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.LastName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.lastName" maxlength="50" :class="{
                      'is-invalid': v$.lastName.$invalid && v$.lastName.$dirty,
                    }" />

                    <small v-if="v$.lastName.$invalid && v$.lastName.$dirty" class="text-danger">
                      {{ $t('CRMSetting.LastNameIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12"><label>{{ $t('CRMSetting.Phone') }}:</label></div>
                  <div class="col-md-12 col-lg-12">
                    <InputMask v-model="addSendTLoanHomiForm.phone" class="form-control" mask="(999) 999-9999"
                      placeholder="(___) ___-____" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Mobile') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <InputMask v-model="addSendTLoanHomiForm.mobile" class="form-control" mask="(999) 999-9999"
                      placeholder="(___) ___-____" :class="{
                        'is-invalid': v$.mobile.$invalid && v$.mobile.$dirty,
                      }" />

                    <small v-if="v$.mobile.$invalid && v$.mobile.$dirty"
                      class="text-danger">{{ $t('CRMSetting.MobileIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Email') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.email" maxlength="100"
                      @change="checkDuplicateEmail(0)" :class="{
                        'is-invalid': v$.email.$invalid && v$.email.$dirty,
                      }" />
                    <small v-if="v$.email.$invalid && v$.email.$dirty"
                      class="text-danger">{{ $t('CRMSetting.EmailIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.SSN') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.ssn" maxlength="11"
                      @focusout="onFocusOutSSN($event)" :class="{
                        'is-invalid': v$.ssn.$invalid && v$.ssn.$dirty,
                      }" />
                    <small v-if="(v$.ssn.$invalid && v$.ssn.$dirty) || isSSNValidate == true" class="text-danger">
                      {{ $t('CRMSetting.SSNMustBeAValidNo') }}.</small>
                    <small v-if="dpAmtValidation == true" class="text-danger">
                      {{ $t('CRMSetting.AmountCantBeGreaterThanSystemCost') }}.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.DOB') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group datepickerinpop">
                      <Calendar v-model="addSendTLoanHomiForm.dateofBirth" showIcon style="width: 100%" :class="{
                        'is-invalid': v$.dateofBirth.$invalid && v$.dateofBirth.$dirty,
                      }" />

                      <small v-if="v$.dateofBirth.$invalid && v$.dateofBirth.$dirty" style="color: red">
                        {{ $t('CRMSetting.DOBIsRequired') }}</small>

                      <!-- <small v-if="dateofBirth.errors?.lessthan18" style="color:red;">Age should be
                                                  greater than 18</small> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtCurrentResidence') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.yearsAtCurrentResidence" @input="
                      yearsAtCurrentResidence(
                        addSendTLoanHomiForm.yearsAtCurrentResidence
                      )
                      " @keypress="keyPressNo($event)" maxlength="3" :class="{
    'is-invalid':
      v$.yearsAtCurrentResidence.$invalid &&
      v$.yearsAtCurrentResidence.$dirty,
  }" />
                    <small v-if="v$.yearsAtCurrentResidence.$invalid &&
                      v$.yearsAtCurrentResidence.$dirty
                      " class="text-danger">{{ $t('CRMSetting.YearsAtCurrentResidenceIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtCurrentResidence') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      @keypress="keyPressNo($event)" v-model="addSendTLoanHomiForm.monthsatCurrentResidence" @input="
                        monthsCurrentResidence(
                          addSendTLoanHomiForm.monthsatCurrentResidence
                        )
                        " :class="{
    'is-invalid':
      v$.monthsatCurrentResidence.$invalid &&
      v$.monthsatCurrentResidence.$dirty,
  }" />
                    <small v-if="v$.monthsatCurrentResidence.$invalid &&
                      v$.monthsatCurrentResidence.$dirty
                      " class="text-danger">{{ $t('CRMSetting.MonthsAtCurrentResidenceIsRequired') }}.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtPreviousResidence') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.yearsAtPreviousResidence"
                      @keypress="keyPressNo($event)" maxlength="3" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtPreviousResidence') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      @keypress="keyPressNo($event)" v-model="addSendTLoanHomiForm.monthsatPreviousResidence" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Street') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.PRStreet" maxlength="50"
                      disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousCity') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.PRCity" maxlength="50"
                      disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousCountry') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.PRcountry" :options="countryLists" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      @clear="onClearCountry(addSendTLoanHomiForm.PRcountry, 'second')"
                      :placeholder="$t('CRMSetting.SelectCountry')" class="w-full md:w-14rem"
                      @change="onCountryChange(addSendTLoanHomiForm.PRcountry, 'second')" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousState') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.PRstate" :options="statesII" showClear optionLabel="text"
                      optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.SelectState')"
                      class="w-full md:w-14rem" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousZipCode') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.PRPostalCode" maxlength="50"
                      disabled />
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousHousingStatus') }}:</label><span class="text-danger"
                      v-if="showValidationIconOnPR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.PHousingStatus" :options="lstprevHousingStatus" showClear
                      optionLabel="text" optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.Select')"
                      class="w-full md:w-14rem" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.EmploymentType') }}:</label><span class="text-danger">*</span>
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.employementTypeID" :options="lstemployementType" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectEmployeeType')"
                      @change="employementTypeID(addSendTLoanHomiForm.employementTypeID)" class="w-full md:w-14rem"
                      :class="{
                        'is-invalid':
                          v$.employementTypeID.$invalid && v$.employementTypeID.$dirty,
                      }" />
                    <small v-if="v$.employementTypeID.$invalid && v$.employementTypeID.$dirty" class="text-danger">{{
                      $t('CRMSetting.EmploymentTypeIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.EmployerName') }}:</label><span v-if="employerName"
                      class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.employerName" maxlength="50" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Occupation') }}:</label><span v-if="occupation" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.occupation" maxlength="50" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtCurrentEmployment') }}:</label><span
                      v-if="addSendTLoanHomiForm.yearsAtCurrentEmployement" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.yearsAtCurrentEmployement"
                      @input="
                        coApp_yearsAtCurrentResidence(
                          addSendTLoanHomiForm.yearsAtCurrentEmployement
                        )
                        " @keypress="keyPressNo($event)" maxlength="3" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtCurrentEmployment') }}:</label><span
                      v-if="monthsAtCurrentEmployement" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      v-model="addSendTLoanHomiForm.monthsAtCurrentEmployement" maxlength="50" @input="
                        monthsCurrentEmployement(
                          addSendTLoanHomiForm.monthsAtCurrentEmployement
                        )
                        " @keypress="keyPressNo($event)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousEmployerName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.previousEmployerName"
                      maxlength="50" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousOccupation') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.previousOccupation"
                      maxlength="50" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtPreviousEmployment') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.yearsAtPreviousEmployement"
                      @keypress="keyPressNo($event)" maxlength="3" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtPreviousEmployment') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      v-model="addSendTLoanHomiForm.monthsAtPreviousEmployement" @input="
                        monthsPreviousEmployement(
                          addSendTLoanHomiForm.monthsAtPreviousEmployement
                        )
                        " @keypress="keyPressNo($event)" maxlength="50" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.IncomeFrequency') }}:<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.lstIncomeFrequencyID" :options="lstIncomeFrequency" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectFrequency')" class="w-full md:w-14rem" @change="
                        lstIncomeFrequencyID(addSendTLoanHomiForm.lstIncomeFrequencyID)
                        " :class="{
    'is-invalid':
      v$.lstIncomeFrequencyID.$invalid &&
      v$.lstIncomeFrequencyID.$dirty,
  }" />
                    <small v-if="v$.lstIncomeFrequencyID.$invalid && v$.lstIncomeFrequencyID.$dirty
                      " class="text-danger">{{ $t('CRMSetting.IncomeFrequencyIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Income') }}:<span class="text-danger"
                        v-if="showValidationIconOn_income">*</span></label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.income"
                          @keypress="numberOnly($event)" @input="income(addSendTLoanHomiForm.income)" maxlength="50"
                          :disabled="incomedisable" :class="{
                            'is-invalid': v$.income.$invalid && v$.income.$dirty,
                          }" />
                      </div>
                      <small v-if="v$.income.$invalid && v$.income.$dirty" class="text-danger">
                        {{ $t('CRMSetting.IncomeFrequency') }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.OtherIncomeFrequency') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.otherIncomeFrequencyID" :options="lstIncomeFrequency"
                      showClear optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectIncomeFrequency')" class="w-full md:w-14rem" @change="
                        otherIncomeFrequencyID(
                          addSendTLoanHomiForm.otherIncomeFrequencyID
                        )
                        " />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12"><label>{{ $t('CRMSetting.OtherIncome') }}:</label></div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.otherIncome"
                          @input="otherIncome(addSendTLoanHomiForm.otherIncome)" @keypress="numberOnly($event)"
                          maxlength="50" :disabled="otherIncomedisable" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.OtherIncomeSource') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.otherIncomeSource"
                      maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.GrossIncome') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.grossIncome"
                          maxlength="50" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--================================================== Co-Applicant Detail: ==============================================================-->

    <div v-if="addSendTLoanHomiForm.IsCoApplicantRequired == true" class="accordion" id="accordionCoApplicant"
      style="margin-top: 15px">
      <div class="accordion-item border-dark">
        <h2 class="accordion-header" id="headingCoApplicant">
          <button class="accordion-button bg-secondary text-white" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseCoApplicant" aria-expanded="true" aria-controls="collapseCoApplicant">
            <span>{{ $t('CRMSetting.Co-ApplicantDetail') }}:</span>
          </button>
        </h2>
        <div id="collapseCoApplicant" class="all_custom_fields accordion-collapse show"
          aria-labelledby="headingCoApplicant" data-bs-parent="#accordionCoApplicant">
          <div class="accordion-body">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.FirstName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_firstName" maxlength="50"
                      :class="{
                        'is-invalid':
                          vc$.coApp_firstName.$invalid && vc$.coApp_firstName.$dirty,
                      }" />
                    <small v-if="vc$.coApp_firstName.$invalid && vc$.coApp_firstName.$dirty" class="text-danger">
                      {{ $t('CRMSetting.FirstNameIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.LastName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_lastName" maxlength="50"
                      :class="{
                        'is-invalid':
                          vc$.coApp_lastName.$invalid && vc$.coApp_lastName.$dirty,
                      }" />
                    <small v-if="vc$.coApp_lastName.$invalid && vc$.coApp_lastName.$dirty" class="text-danger">
                      {{ $t('CRMSetting.LastNameIsRequired') }} </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12"><label>{{ $t('CRMSetting.Phone') }}:</label></div>
                  <div class="col-md-12 col-lg-12">
                    <InputMask v-model="addSendTLoanHomiForm.coApp_phone" class="form-control" mask="(999) 999-9999"
                      placeholder="(___) ___-____" />
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Mobile') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <InputMask v-model="addSendTLoanHomiForm.coApp_mobile" class="form-control" mask="(999) 999-9999"
                      placeholder="(___) ___-____" :class="{
                        'is-invalid':
                          vc$.coApp_mobile.$invalid && vc$.coApp_mobile.$dirty,
                      }" />
                    <small v-if="vc$.coApp_mobile.$invalid && vc$.coApp_mobile.$dirty" class="text-danger">
                      {{ $t('CRMSetting.MobileIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Email') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_email" maxlength="100"
                      @change="checkDuplicateEmail(1)" @keyup="onFocusOutEmail($event)" :class="{
                        'is-invalid': vc$.coApp_email.$invalid && vc$.coApp_email.$dirty,
                      }" />
                    <small v-if="vc$.coApp_email.$invalid && vc$.coApp_email.$dirty" class="text-danger">
                      {{ $t('CRMSetting.EmailIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.SSN') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_ssn" maxlength="11"
                      @focusout="onFocusOutSSN($event)" :class="{
                        'is-invalid': vc$.coApp_ssn.$invalid && vc$.coApp_ssn.$dirty,
                      }" />
                    <small v-if="vc$.coApp_ssn.$invalid && vc$.coApp_ssn.$dirty" class="text-danger">
                      {{ $t('CRMSetting.SSNIsRequired') }} </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.DOB') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group datepickerinpop">
                      <Calendar v-model="addSendTLoanHomiForm.coApp_dateofBirth" showIcon style="width: 100%" :class="{
                        'is-invalid':
                          vc$.coApp_dateofBirth.$invalid &&
                          vc$.coApp_dateofBirth.$dirty,
                      }" />
                      <small v-if="vc$.coApp_dateofBirth.$invalid && vc$.coApp_dateofBirth.$dirty
                        " class="text-danger">{{ $t('CRMSetting.DOBIsRequired') }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="custom-control custom-checkbox mb-2" style="font-size: 16px">
                  <input type="checkbox" class="custom-control-input" v-model="addSendTLoanHomiForm.sameAsapplicant"
                    id="sameAsapplicantID" @change="sameAsapplicant(addSendTLoanHomiForm.sameAsapplicant)" />
                  <label class="custom-control-label" for="sameAsapplicantID">{{ $t('CRMSetting.AddressSameAsApplicant')
                  }}.</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Street') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_street" maxlength="50"
                      :class="{
                        'is-invalid':
                          vc$.coApp_street.$invalid && vc$.coApp_street.$dirty,
                      }" />
                    <small v-if="vc$.coApp_street.$invalid && vc$.coApp_street.$dirty" class="text-danger">
                      {{ $t('CRMSetting.StreetIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.City') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_city" maxlength="50"
                      :class="{
                        'is-invalid': vc$.coApp_city.$invalid && vc$.coApp_city.$dirty,
                      }" />
                    <small v-if="vc$.coApp_city.$invalid && vc$.coApp_city.$dirty" class="text-danger">
                      {{ $t('CRMSetting.CityIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Country') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_country" :options="countryLists" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectCountry')" class="w-full md:w-14rem" @change="
                        onCountryChange(addSendTLoanHomiForm.coApp_country, 'third')
                        " @clear="onClearCountry(addSendTLoanHomiForm.coApp_country, 'third')" :class="{
    'is-invalid':
      vc$.coApp_country.$invalid && vc$.coApp_country.$dirty,
  }" />
                    <small v-if="vc$.coApp_country.$invalid && vc$.coApp_country.$dirty" class="text-danger">
                      {{ $t('CRMSetting.CountryIsRequired') }} </small>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.State') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coAppstate" :options="statesIII" showClear optionLabel="text"
                      optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.SelectState')"
                      class="w-full md:w-14rem" :class="{
                        'is-invalid': vc$.coAppstate.$invalid && vc$.coAppstate.$dirty,
                      }" />
                    <small v-if="vc$.coAppstate.$invalid && vc$.coAppstate.$dirty" class="text-danger">
                      {{ $t('CRMSetting.StateIsRequired') }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.ZipCode') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_postalCode" maxlength="50"
                      :class="{
                        'is-invalid':
                          vc$.coApp_postalCode.$invalid && vc$.coApp_postalCode.$dirty,
                      }" />
                    <small v-if="vc$.coApp_postalCode.$invalid && vc$.coApp_postalCode.$dirty" class="text-danger">
                      {{ $t('CRMSetting.ZipCodeIsRequired') }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.YearsAtCurrentResidence') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_yearsAtCurrentResidence"
                      maxlength="3" @input="
                        coApp_yearsAtCurrentResidence(
                          addSendTLoanHomiForm.coApp_yearsAtCurrentResidence
                        )
                        " @keypress="keyPressNo($event)" :class="{
    'is-invalid':
      vc$.coApp_yearsAtCurrentResidence.$invalid &&
      vc$.coApp_yearsAtCurrentResidence.$dirty,
  }" />
                    <small v-if="vc$.coApp_yearsAtCurrentResidence.$invalid &&
                      vc$.coApp_yearsAtCurrentResidence.$dirty
                      " class="text-danger"> {{ $t('CRMSetting.YearsAtCurrentResidenceIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.MonthsAtCurrentResidence') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      v-model="addSendTLoanHomiForm.coApp_monthsAtCurrentResidence" maxlength="2" @input="
                        coApp_monthsCurrentResidence(
                          addSendTLoanHomiForm.coApp_monthsAtCurrentResidence
                        )
                        " @keypress="keyPressNo($event)" :class="{
    'is-invalid':
      vc$.coApp_monthsAtCurrentResidence.$invalid &&
      vc$.coApp_monthsAtCurrentResidence.$dirty,
  }" />
                    <small v-if="vc$.coApp_monthsAtCurrentResidence.$invalid &&
                      vc$.coApp_monthsAtCurrentResidence.$dirty
                      " class="text-danger"> {{ $t('CRMSetting.MonthsAtCurrentResidenceIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.CurrentHousingStatus') }}:</label><span class="text-danger"></span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.CoHousingStatus" :options="lstCurrHousingStatus" showClear
                      optionLabel="text" optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.Select')"
                      disabled class="w-full md:w-14rem" :class="{
                        'is-invalid':
                          vc$.CoHousingStatus.$invalid && vc$.CoHousingStatus.$dirty,
                      }" />
                    <small v-if="vc$.CoHousingStatus.$invalid && vc$.CoHousingStatus.$dirty" class="text-danger">
                      {{ $t('CRMSetting.CurrentHousingStatusIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.YearsAtPreviousResidence') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_yearsAtPreviousResidence"
                      @keypress="keyPressNo($event)" maxlength="3" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtPreviousResidence') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      @keypress="keyPressNo($event)" v-model="addSendTLoanHomiForm.coApp_monthsatPreviousResidence"
                      disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Street') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_PRStreet" maxlength="50"
                      disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousCity') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_PRCity" maxlength="50"
                      disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousCountry') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_PRcountry" :options="countryLists" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectCountry')" class="w-full md:w-14rem" @clear="
                        onClearCountry(addSendTLoanHomiForm.coApp_PRcountry.value, 'four')
                        " @change="
    onCountryChange(
      addSendTLoanHomiForm.coApp_PRcountry.value,
      'four'
    )
    " disabled />
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousState') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_PRstate" :options="statesIV" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectState')" class="w-full md:w-14rem" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousZipCode') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_PRPostalCode"
                      maxlength="50" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousHousingStatus') }}:</label><span class="text-danger"
                      v-if="addSendTLoanHomiForm.showValidationIconOnCo_PR">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.CoPHousingStatus" :options="lstprevHousingStatus" showClear
                      optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.SelectCountry')" class="w-full md:w-14rem" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.EmploymentType') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_employementTypeID" :options="lstemployementType"
                      showClear optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.Select')" @change="
                        coApp_employementTypeID(
                          addSendTLoanHomiForm.coApp_employementTypeID
                        )
                        " class="w-full md:w-14rem" :class="{
    'is-invalid':
      vc$.coApp_employementTypeID.$invalid &&
      vc$.coApp_employementTypeID.$dirty,
  }" />
                    <small v-if="vc$.coApp_employementTypeID.$invalid &&
                      vc$.coApp_employementTypeID.$dirty
                      " class="text-danger">{{ $t('CRMSetting.EmploymentTypeIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.EmployerName') }}:</label><span
                      v-if="addSendTLoanHomiForm.coApp_employerName" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_employerName"
                      maxlength="50" :class="{
                        'is-invalid':
                          vc$.coApp_employerName.$invalid &&
                          vc$.coApp_employerName.$dirty,
                      }" />
                    <small v-if="vc$.coApp_employerName.$invalid && vc$.coApp_employerName.$dirty
                      " class="text-danger">{{ $t('CRMSetting.EmployerNameIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Occupation') }}:</label><span v-if="addSendTLoanHomiForm.coApp_occupation"
                      class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_occupation" maxlength="50"
                      :class="{
                        'is-invalid':
                          vc$.coApp_occupation.$invalid && vc$.coApp_occupation.$dirty,
                      }" />
                    <small v-if="vc$.coApp_occupation.$invalid && vc$.coApp_occupation.$dirty" class="text-danger">{{
                      $t('CRMSetting.OccupationIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtCurrentEmployment') }}:</label><span
                      v-if="addSendTLoanHomiForm.coApp_yearsAtCurrentEmployement" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_yearsAtCurrentEmployement"
                      @input="
                        coApp_yearsAtCurrentEmployement(
                          addSendTLoanHomiForm.coApp_yearsAtCurrentEmployement
                        )
                        " @keypress="keyPressNo($event)" maxlength="3" :class="{
    'is-invalid':
      vc$.coApp_yearsAtCurrentEmployement.$invalid &&
      vc$.coApp_yearsAtCurrentEmployement.$dirty,
  }" />
                    <small v-if="vc$.coApp_yearsAtCurrentEmployement.$invalid &&
                      vc$.coApp_yearsAtCurrentEmployement.$dirty
                      " class="text-danger">{{ $t('CRMSetting.YearsAtCurrentEmploymentIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtCurrentEmployment') }}:</label><span
                      v-if="addSendTLoanHomiForm.coApp_monthsAtCurrentEmployement" class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EntervalueBetween1To11')"
                      v-model="addSendTLoanHomiForm.coApp_monthsAtCurrentEmployement" @input="
                        coApp_monthsCurrentEmployement(coApp_monthsAtCurrentEmployement)
                        " @keypress="keyPressNo($event)" maxlength="50" :class="{
    'is-invalid':
      vc$.coApp_monthsAtCurrentEmployement.$invalid &&
      vc$.coApp_monthsAtCurrentEmployement.$dirty,
  }" />
                    <small v-if="vc$.coApp_monthsAtCurrentEmployement.$invalid &&
                      vc$.coApp_monthsAtCurrentEmployement.$dirty
                      " class="text-danger">{{ $t('CRMSetting.MonthsAtCurrentEmploymentIsRequired') }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousEmployerName') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_previousEmployerName"
                      maxlength="50" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.PreviousOccupation') }}:</label><span class="text-danger">*</span>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_previousOccupation"
                      maxlength="50" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.YearsAtPreviousEmployment') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control"
                      v-model="addSendTLoanHomiForm.coApp_yearsAtPreviousEmployement" @keypress="keyPressNo($event)"
                      maxlength="3" disabled />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.MonthsAtPreviousEmployment') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" :placeholder="$t('CRMSetting.EnterValueBetween1To11')"
                      v-model="addSendTLoanHomiForm.coApp_monthsAtPreviousEmployement" @input="
                        coApp_monthsPreviousEmployement(
                          addSendTLoanHomiForm.coApp_monthsAtPreviousEmployement
                        )
                        " @keypress="keyPressNo($event)" maxlength="50" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.IncomeFrequency') }}:<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_incomeFrequency" :options="lstIncomeFrequency" showClear
                      optionLabel="text" optionValue="value" style="width: 100%" :placeholder="$t('CRMSetting.Select')"
                      @change="
                        coApp_incomeFrequency(addSendTLoanHomiForm.coApp_incomeFrequency)
                        " class="w-full md:w-14rem" :class="{
    'is-invalid':
      vc$.coApp_incomeFrequency.$invalid &&
      vc$.coApp_incomeFrequency.$dirty,
  }" />

                    <small v-if="vc$.coApp_incomeFrequency.$invalid &&
                      vc$.coApp_incomeFrequency.$dirty
                      " class="text-danger">{{ $t('CRMSetting.IncomeFrequencyIsRequired') }}</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.Income') }}:<span class="text-danger"
                        v-if="addSendTLoanHomiForm.showValidationIconOn_coApp_income">*</span></label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.coApp_income"
                          @input="coApp_income(addSendTLoanHomiForm.coApp_income)" maxlength="50"
                          @keypress="numberOnly($event)" :class="{
                            'is-invalid':
                              vc$.coApp_income.$invalid && vc$.coApp_income.$dirty,
                          }" />
                        <small v-if="vc$.coApp_income.$invalid && vc$.coApp_income.$dirty" class="text-danger">
                          {{ $t('CRMSetting.IncomeIsRequired') }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.OtherIncomeFrequency') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="addSendTLoanHomiForm.coApp_otherIncomeFrequency" :options="lstIncomeFrequency"
                      showClear optionLabel="text" optionValue="value" style="width: 100%"
                      :placeholder="$t('CRMSetting.Select')" @change="
                        coApp_otherIncomeFrequency(
                          addSendTLoanHomiForm.coApp_otherIncomeFrequency
                        )
                        " class="w-full md:w-14rem" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12"><label>{{ $t('CRMSetting.OtherIncome') }}:</label></div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.coApp_otherIncome" @input="
                          coApp_otherIncome(addSendTLoanHomiForm.coApp_otherIncome)
                          " @keypress="numberOnly($event)" maxlength="50" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label> {{ $t('CRMSetting.OtherIncomeSource') }}:</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" class="form-control" v-model="addSendTLoanHomiForm.coApp_otherIncomeSource"
                      maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row mb-2">
                  <div class="col-md-12 col-lg-12">
                    <label>{{ $t('CRMSetting.GrossIncome') }}:<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ currencyFormat }}</span>
                        <input type="number" class="form-control" v-model="addSendTLoanHomiForm.coApp_grossIncome"
                          maxlength="50" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--======================================================================================================================================-->
    <!--================================================== Check Box ===========================================================-->
    <div class="custom-control custom-checkbox mt-3">
      <input type="checkbox" class="custom-control-input" v-model="addSendTLoanHomiForm.IsCoApplicantRequired"
        @change="IsCoApplicantRequired(addSendTLoanHomiForm.IsCoApplicantRequired)" id="forco-applicant" />
      <label class="custom-control-label" for="forco-applicant">
        {{ $t('CRMSetting.IsCo-ApplicantRequired') }}.
      </label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="checkBoxId1"
        v-model="addSendTLoanHomiForm.isAutoPaymentcheckBox" />
      <label class="custom-control-label" for="checkBoxId1">
        {{ $t('CRMSetting.AgreeToAutoPaymentProcess') }}</label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="checkId2" v-model="addSendTLoanHomiForm.isTermCheckBox"
        @change="termCheck($event)" :class="{
          'is-invalid': v$.isTermCheckBox.$invalid && v$.isTermCheckBox.$dirty,
        }" />
      <label class="custom-control-label" for="checkId2">
        <span class="text-danger">*</span> {{ $t('CRMSetting.TermAndCondition') }}.</label>
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="checkId3" v-model="addSendTLoanHomiForm.isBorrowers"
        @change="borrowersCheck($event)" :class="{
          'is-invalid': v$.isBorrowers.$invalid && v$.isBorrowers.$dirty,
        }" />
      <label class="custom-control-label" for="checkId3">
        <span class="text-danger">*</span>
        {{ $t('CRMSetting.individualesAuthorize') }}
        {{ companyName }}
        {{ $t('CRMSetting.SoftCreditionalReport') }}.
      </label>
    </div>
    <!--===========================================================================================================================-->

    <div class="modal-footer mt-4 p-0 pt-3">
      <a href="javascript:void(0);" class="btn btn-success form-btns" @click="onSubmit()"><i
          class="fa fa-arrow-right"></i> {{ $t('CRMSetting.Next') }}</a>
      <button type="submit" class="btn btn-white form-btns" @click="clearForm()" data-dismiss="modal" aria-label="Close">
        <i class="fa feather-repeat text-white"></i> {{ $t('CRMSetting.ResetLabel') }}
      </button>
    </div>
  </form>

  <!--//=================showPreview Page===============-->

  <div v-if="showPreviewSendTLoanHomiForm" class="standalone-page-container">
    <div class="panel" style="border: 0px !important">
      <div class="panel-content">
        <h3 class="form-heading mt-0">
          <span>{{ $t('CRMSetting.SystemInfo') }}:</span>
        </h3>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.LoanProduct') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">
                {{ sendToLoanHomiPreviewDetail.LoanProductId }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Term') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.Term }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Country') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.country }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.State') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.BillingState
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.City') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.BillingCity
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Street') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.BillingStreet
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.ZipCode') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.BillingPostalCode
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.TotalAmount') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.Total_System_CostfView
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.DownpaymentAmount') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.Downpayment_AmountfView
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.LoanAmount') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.Loan_AmountfView
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.NoOfMortgages') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.NoofMortgages
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OwnTheProperty') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.Owntheproperty
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.SalesRepName') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.InstallerRepName
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Agreement') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ fileName }}</span>
            </div>
          </div>
        </div>
      </div>
      <h3 class="form-heading mt-3">
        <span>{{ $t('CRMSetting.ApplicantDetail') }}:</span>
      </h3>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.FirstName') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.FirstName
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.LastName') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.LastName
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Phone') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.Phone }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Mobile') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.MobilePhone
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Email') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.Email
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.SSN') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.SSN }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.DOB') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.DOBfView }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtCurrentResidence') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.YearsACA }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtCurrentResidence') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.MonthsACA
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtPreviousResidence') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.PYearACR }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtPreviousResidence') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.PMonthACR
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousCountry') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PRcountry
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousState') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.PRstate
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousCity') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.PRCity }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Street') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.PRStreet
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousZipCode') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PRPostalCode
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousHousingStatus') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PHousingStatus
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.EmploymentType') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.EmployerType
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.EmployerName') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.Employer }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Occupation') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6">
              <span class="py-2 d-block" translate="no">{{
                sendToLoanHomiPreviewDetail.Occupation
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtCurrentEmployment') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.YearsACE }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtCurrentEmployment') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.MonthsACE
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--===============================================Previous employeor details===========================================-->
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousEmployerName') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PEmployerName
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousOccupation') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.POccupation
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtPreviousEmployment') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PYearsACE
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtPreviousEmployment') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.PMonthsACE
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--=================================================================================================-->

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.IncomeFrequency') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.IncomeFreq
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Income') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.IncomefView
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncomeFrequency') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.OIncomeFreq
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncome') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.OIncomeMonthlystr
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncomeSource') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.OIncomeSource
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.GrossIncome') }}:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{
                sendToLoanHomiPreviewDetail.GrossIncomefView
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="IsCoApplicantRequired.value">
        <h3 class="form-heading mt-3">
          <span>{{ $t('CRMSetting.Co-ApplicantDetail') }}:</span>
        </h3>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.FirstName') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coFirstname
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.LastName') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coLastname
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Phone') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPhone
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Mobile') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coMobilePhone
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Email') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coEmail
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.SSN') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{ sendToLoanHomiPreviewDetail.coSSN }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.DOB') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coDOBfView
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Country') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coApp_country
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.State') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coMailingState
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.City') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coMailingCity
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Street') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coMailingStreet
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.ZipCode') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coMailingPostalCode
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtCurrentResidence') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coYearsACA
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtCurrentResidence') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coMonthsACA
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.CurrentHousingStatus') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.CoHousingStatus
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtPreviousResidence') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPYearACR
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtPreviousResidence') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coPMonthACR
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Country') }}Country:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPRcountry
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.State') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coPRstate
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.City') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPRCity
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Street') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coPRStreet
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.ZipCode') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPRPostalCode
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousHousingStatus') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.CoPHousingStatus
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.EmploymentType') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coEmployerType
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.EmployerName') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coEmployer
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Occupation') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coOccupation
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtCurrentEmployment') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coYearsACE
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0" translate="no">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtCurrentEmployment') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6">
                <span class="py-2 d-block" translate="no">{{
                  sendToLoanHomiPreviewDetail.coMonthsACE
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!--===============================================Co-Applicant Previous employeor details===========================================-->
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousEmployerName') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPEmployerName
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.PreviousOccupation') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPOccupation
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YearsAtPreviousEmployment') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPYearsACE
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.MonthsAtPreviousEmployment') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coPMonthsACE
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--=================================================================================================-->

        <div class="row"></div>
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.IncomeFrequency') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coIncomeFreq
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.Income') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.CoIncomefView
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncomeFrequency') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.CoOIncomeFreq
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncome') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coOIncome
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.OtherIncomeSource') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coOIncomeSource
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="input-group border-bottom mb-2">
              <div class="col-sm-12 col-md-6 px-0">
                <span class="py-2 d-block"><strong>{{ $t('CRMSetting.GrossIncome') }}:</strong></span>
              </div>
              <div class="col-sm-12 col-md-6" translate="no">
                <span class="py-2 d-block">{{
                  sendToLoanHomiPreviewDetail.coGrossIncomefView
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-------------------->
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="input-group border-bottom mb-2">
            <div class="col-sm-12 col-md-6 px-0">
              <span class="py-2 d-block"><strong>{{ $t('CRMSetting.YouAreAgreeingToTheAutoPaymentProcess')
              }}.:</strong></span>
            </div>
            <div class="col-sm-12 col-md-6" translate="no">
              <span class="py-2 d-block">{{ AutoPaymentStatus }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href="javascript:void(0);" class="btn btn-dark form-btns" @click="onBack()"><i class="fa fa-arrow-left"></i>
        {{ $t('CRMSetting.BackLabel') }}</a>
      <a href="javascript:void(0);" class="btn btn-success form-btns" @click="onPrevSubmit()"
        v-if="disablePrevSubmitBtn"><i class="feather-save"></i> {{ $t('CRMSetting.SubmitLabel') }}</a>
    </div>
  </div>

  <Loading v-model:active="isLoading">
  </Loading>

  <!--===========================================-->
  <!--=================================================== WaringPopup ==================================================================-->

  <div v-if="isshowwarning" class="modal-container ">
    <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"> {{ $t('CRMSetting.Warning') }} </h5>

          <a class="modal-close" @click="closeWaringPopup()"><i class="fa fa-times"></i></a>
        </div>
        <div class="modal-body">

          <div class="col-md-12 col-lg-12 p-0">
            <div class="w-100">
              <p>
                <strong>{{ $t('CRMSetting.Dear') }} {{ rUserName }}</strong>
              </p>
              <p>
                {{ $t('CRMSetting.ThanksForAppling') }}
                <strong>{{ rDataLoanAppId }}</strong> {{ $t('CRMSetting.ForFutureReference') }}.
              </p>
              <p>
                {{ $t('CRMSetting.Unfortunately') }}
              </p>
              <p>
                {{ $t('CRMSetting.Portal') }}
              </p>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-danger form-btns" @click="closeWaringPopup()" data-dismiss="modal"
            aria-label="Close">
            <i class="fa fa-times text-white"></i> {{ $t('CRMSetting.CloseLabel') }}
          </button>

        </div>
      </div>
    </div>
  </div>


  <!--====================================================================================================================================-->
  <!--=================================================== ResponsePopup ==================================================================-->

  <div v-if="isshowresponse" class="modal-container ">
    <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"> {{ $t('CRMSetting.Congratulations') }} </h5>

          <a class="modal-close" @click="closeResponsePopup()"><i class="fa fa-times"></i></a>
        </div>
        <div class="modal-body">

          <div class="col-md-12 col-lg-12 p-0">
            <div class="alert alert-success" role="alert">
              <i class="feather-check mr-2"></i> <strong> {{ $t('CRMSetting.Success') }}:</strong>
              {{ $t('CRMSetting.LoanApplicationSuccessfullyAdded') }}
            </div>
            <div class="w-100">
              <p>
                <strong> {{ $t('CRMSetting.Dear') }} {{ rUserName }}</strong>
              </p>
              <p>
                {{ $t('CRMSetting.ThanksForAppling') }}
                <strong>{{ rDataLoanAppId }}</strong> {{ $t('CRMSetting.ForFutureReference') }}.
              </p>
              <p>
                {{ $t('CRMSetting.YourCreditScoreCategoryIs') }} <strong>{{ creditScoreCategory }}</strong>
              </p>
              <p>
                {{ $t('CRMSetting.YourApplicationHasBeenApprovedFortheLoanProcess') }}
              </p>

              <div v-if="mandatoryDocuments != null">
                <p><strong>Mandatory Documents:</strong></p>
                <ol class="pl-2">
                  <li v-for="item of mandatoryDocuments" :key="item.id">
                    {{ item.masterValue }}
                  </li>
                </ol>
              </div>

              <p class="mt-4">
                {{ $t('CRMSetting.IncomeVerificationRequired') }}
                <strong>{{ IncomeVerificationValue }}</strong>
              </p>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-danger form-btns" @click="closeResponsePopup()" data-dismiss="modal"
            aria-label="Close">
            <i class="fa fa-times text-white"></i> {{ $t('CRMSetting.CloseLabel') }}
          </button>

        </div>
      </div>
    </div>
  </div>

  <!--====================================================================================================================================-->
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from "vue";

//Components
import assestcategorylist from "@/views/crm/assetcategory/assetcategorylist.vue";
import { required, maxValue, minValue, helpers, decimal } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import SimpleDialog from "@/views/shared/SimpleDialog.vue";
import { createConfirmDialog } from "vuejs-confirm-dialog";
import CommonService from "@/service/crmservice/commonService";
import LoanApplicationService from "@/service/crmservice/loanapplicationservice";
import { useRouter, useRoute } from "vue-router";
import { createToaster } from "@meforma/vue-toaster";
import InputMask from "primevue/inputmask";
import { email } from "@vuelidate/validators";
import { useI18n } from 'vue-i18n'

//============================================================== class =======================================================================//

class sendToLoanHomiModel {
  OpportunityId;
  ProposalId;
  ContactId;
  AccountId;
  ContractId;
  LoanProductId;
  InstallerRepNameId;
  InstallerRepName;
  OppOwnerId;
  Financial_InstitutionId;
  loanProduct;
  DealerName;
  DealerAccountId;
  Term;
  country;
  BillingState;//state
  MailingState;
  BillingStreet;//street
  BillingCity;//city
  MailingCity;
  BillingPostalCode;//postalCode
  System_Size_kW;//systemSizeKW
  Total_System_Cost;//totalSystemCost
  Total_System_CostfView;//totalSystemCost For view
  Downpayment_AmountfView; //downpaymentAmount For view  
  Downpayment_Amount; //downpaymentAmount
  Loan_Amount;//loanAmount
  Loan_AmountfView;//loanAmount For view  
  Owntheproperty;//ownthePropertyID: string;
  NoofMortgages;//noOfMortgages: string;
  FirstName;
  LastName;
  Phone;
  MobilePhone;
  Email;
  SSN;//ssn: string;
  DOB;
  DOBfView;
  YearsACA;//yearsAtCurrentResidence: string;
  MonthsACA;//monthsatCurrentResidence: string;
  PYearACR;
  PMonthACR;
  PRcountry;
  PRstate;
  PRCity;
  PRStreet;
  PRPostalCode;
  PHousingStatus;
  EmployerType;//employementTypeID: string;
  EmployerTypeName;
  Employer;//employerName
  YearsACE;// yearsAtCurrentEmployement: string;
  MonthsACE;//monthsAtCurrentEmployement: string;
  PEmployerName;//previousEmployerName: string;
  coPEmployerName;
  POccupation;//previousOccupation: string;
  coPOccupation;
  coPYearsACE;
  coPMonthsACE;
  PYearsACE;//yearsAtPreviousEmployement: string;
  PMonthsACE;//monthsAtPreviousEmployement: string;
  IncomeFreq;// lstIncomeFrequencyID: string;
  Income;//income: string;
  OIncomeFreq;//otherIncomeFrequencyID: string;
  //otherIncome: string;
  IncomefView;//income for view: string;

  OIncomeMonthly;//otherIncome: string;
  OIncomeMonthlystr;//otherIncome: string;
  OIncomeSource;//otherIncomeSource: string;
  GrossIncome;// grossIncome: string;
  GrossIncomefView;// grossIncome: string;coGrossIncomefView

  coGrossIncomefView;// grossIncome: string;coGrossIncomef
  Occupation;//occupation
  coFirstname;//coApp_firstName
  coLastname;//coApp_lastName
  coPhone;//coApp_phone
  coMobilePhone;
  coEmail;//coApp_email
  coDINumber;
  coSSN;//coApp_ssn
  coDOB;//coApp_dateofBirth
  coDOBfView;//coApp_dateofBirth For view

  //sameAsapplicant: string;
  coApp_country;
  coState;//coAppstate: string;
  coMailingState;
  coDLState;
  coDLStateLabel;
  coHousingStatus;
  coCity;//coApp_city: string;
  coMailingCity;

  // coStreetName: string;//coApp_street: string; coStreetName
  coMailingStreet;


  coAptSt;
  coStreetType;
  coRuralRoute;
  coPOBox;


  coMailingPostalCode;//coApp_postalCode

  coYearsACA;
  coMonthsACA;
  coPYearACR;
  coPMonthACR;
  coPRcountry;
  coPRstate;
  coPRCity;
  coPRStreet;
  coPRPostalCode;
  CoPHousingStatus;
  CoHousingStatus;
  coRentMortage;
  coBusinessPhone;


  coOccupation;//coApp_occupation
  coYearsACE;//
  coMonthsACE;//

  //coApp_yearsAtCurrentEmployement: string;
  // coApp_monthsAtCurrentEmployement: string;
  coEmployerType;//coApp_employementTypeID
  coEmployerTypeName;
  coEmployer;//coApp_employerName
  CoOIncomeFreq;//coApp_incomeFrequency: string;
  coIncomeFreq;
  CoIncome;//coApp_income: string;
  CoIncomefView;//coApp_income: string For view;
  //coApp_otherIncomeFrequency: string;
  coOIncome;//coApp_otherIncome: string;
  coOIncomeSource;//coApp_otherIncomeSource: string;
  coGrossIncome;//coApp_grossIncome
  Iscoapplicant;//IsCoApplicantRequired: boolean;
  AutoPayment;//isAutoPaymentcheckBox: boolean;
  IsDocsSigned;//isTermCheckBox: boolean;
  CustomerSignedDate;
  isBorrowers;
  IsOE;
  coIsOE;
  CreatedAt;
  UpdatedAt;
  ReqFrom;
  CompanyId;
  CreatedBy;
  SIN;
  SalesRep;
  constructor() {
    this.OpportunityId = null;
    this.ProposalId = null;
    this.ContactId = null;
    this.AccountId = null;
    this.ContractId = null;
    this.LoanProductId = null;
    this.InstallerRepNameId = null;
    this.OppOwnerId = null;
    this.Financial_InstitutionId = null;
    this.loanProduct = null;
    this.DealerName = null;
    this.DealerAccountId = null;
    this.Term = null;
    this.country = null;
    this.BillingState = null;
    this.MailingState = null;
    this.BillingStreet = null;
    this.BillingCity = null;
    this.MailingCity = null;
    this.BillingPostalCode = null;
    this.System_Size_kW = null;
    this.Total_System_Cost = null;
    this.Downpayment_Amount = null;

    this.Total_System_CostfView = null;
    this.Downpayment_AmountfView = null;
    this.Loan_Amount = null;
    this.Loan_AmountfView = null;
    this.Owntheproperty = null;//this.ownthePropertyID = "";
    this.NoofMortgages = null;//this.noOfMortgages = "";
    this.FirstName = null;
    this.LastName = null;
    this.Phone = null;
    this.MobilePhone = null,
      this.Email = null;
    this.SSN = null;//this.ssn = "";
    this.DOB = null;
    this.YearsACA = null;//this.yearsAtCurrentResidence = "";
    this.MonthsACA = null;//this.monthsatCurrentResidence = "";
    this.PYearACR = null;
    this.PMonthACR = null;
    this.PRcountry = null;
    this.PRstate = null;
    this.PRCity = null;
    this.PRStreet = null;
    this.PRPostalCode = null;
    this.PHousingStatus = null;
    this.EmployerType = null;
    this.EmployerTypeName = null;
    this.Employer = null;
    this.YearsACE = null;//this.yearsAtCurrentEmployement = "";
    this.MonthsACE = null;//this.monthsAtCurrentEmployement = "";
    this.PEmployerName = null;
    this.coPEmployerName = null;//this.previousEmployerName = "";
    this.POccupation = null;//this.previousOccupation = "";
    this.coPOccupation = null;
    this.coPYearsACE = null;
    this.coPMonthsACE = null;
    this.PYearsACE = null;//this.yearsAtPreviousEmployement = "";
    this.PMonthsACE = null;//this.monthsAtPreviousEmployement = "";
    this.IncomeFreq = null;//this.lstIncomeFrequencyID = "";
    this.Income = null;// this.income = "";
    this.IncomefView = null;// this.income = "";
    this.OIncomeFreq = null;//this.otherIncomeFrequencyID = "";
    this.OIncomeMonthly = null;//this.otherIncome = "";
    this.OIncomeSource = null;//this.otherIncomeSource = "";
    this.GrossIncome = null;//this.grossIncome = "";
    this.Occupation = null;
    this.coFirstname = null;
    this.coLastname = null;
    this.coPhone = null;
    this.coMobilePhone = null;
    this.coEmail = null;
    this.coDINumber = null;
    this.coSSN = null;
    this.coDOB = null;
    this.DOBfView = null;
    this.coDOBfView = null;
    // this.sameAsapplicant = "";
    this.coApp_country = null;
    //this.coState = "";//this.coState = "";
    this.coMailingState = null;
    this.coDLState = null;
    this.coDLStateLabel = null;
    this.coHousingStatus = null;
    //this.coCity = "";//this.coCity = "";
    this.coMailingCity = null;
    //this.coStreetName = "";//this.coStreetName = "";
    this.coMailingStreet = null;
    this.coAptSt = null;
    this.coStreetType = null;
    this.coRuralRoute = null;
    this.coPOBox = null;

    this.coMailingPostalCode = null;

    this.coYearsACA = null;
    this.coMonthsACA = null;
    this.coPYearACR = null;
    this.coPMonthACR = null;
    this.coPRcountry = null;
    this.coPRstate = null;
    this.coPRCity = null;
    this.coPRStreet = null;
    this.coPRPostalCode = null;
    this.CoPHousingStatus = null;
    this.CoHousingStatus = null;
    this.coRentMortage = null;
    this.coBusinessPhone = null;
    this.coOccupation = null;
    this.coYearsACE = null;//
    this.coMonthsACE = null;//
    this.coEmployerType = null;
    this.coEmployerTypeName = null;
    this.coEmployer = null;
    this.CoOIncomeFreq = null;//this.coIncomeFreq = "";
    this.coIncomeFreq = null;
    this.CoIncomefView = null;
    this.CoIncome = null;//this.coApp_income = "";
    this.coOIncome = null;// this.coApp_otherIncome = "";
    this.coOIncomeSource = null;//this.coApp_otherIncomeSource = "";
    this.coGrossIncome = null;
    this.coGrossIncomefView = null;
    this.GrossIncomefView = null;
    this.Iscoapplicant = false;//this.IsCoApplicantRequired =false;
    this.AutoPayment = true;//this.isAutoPaymentcheckBox = false;
    this.IsDocsSigned = null;//this.isTermCheckBox = false;
    this.CustomerSignedDate = null;
    this.isBorrowers = false;
    this.IsOE = false;
    this.coIsOE = false;
    this.CreatedAt = null;
    this.UpdatedAt = null;
    this.ReqFrom = "StandAlone";
    this.CompanyId = 0;
    this.CreatedBy = null;
    this.SIN = null;
    this.SalesRep = null;
  }
}

class sendToLoanHomiModelJsonData {
  FormJsonData;
  AuthToken;
  constructor() {
    this.FormJsonData = "";
    this.AuthToken = null;
  }
}

//============================================================== variable =======================================================================//
const commonService = ref(new CommonService());
const { t } = useI18n();
const loanApplicationService = ref(new LoanApplicationService());
const opportunityId = ref(null);
const loadSave = ref(false);
const isLoading = ref(false);
const lstowntheProperty = ref(null);
const lstprevHousingStatus = ref(null);
const lstCurrHousingStatus = ref(null);
const installerRepNameList = ref(null);
const lstemployementType = ref(null);
const lstemployementTypeCode = ref(null);
const lstIncomeFrequency = ref(null);
const lstIncomeFrequencyCode = ref(null);
const ShowCo_App_PreviousEmployerDetails = ref(false);
const countryLists = ref(null);
const states = ref(null);
const statesII = ref(null);
const statesIII = ref(null);
const statesIV = ref(null);
const totalLoanAmt = ref(null);
const loanAmt = ref(null);
const totalGrossAmt = ref(null);
const incomeType = ref(null);
const otherIncomeType = ref(null);
const totalOtherFreqIncome = ref(0);
const totalCo_App_GrossAmt = ref(null);
const coApp_incomeType = ref(null);
const coApp_otherIncomeType = ref(null);
const Co_App_totalOtherFreqIncome = ref(0);
const ShowotherIncomeFrequency = ref(false);
const ShowIncomeFrequency = ref(false);
const show_CoApp_IncomeFrequency = ref(false);
const show_CoApp_otherIncomeFrequency = ref(false);
const sendToLoanHomiDataModel = ref(new sendToLoanHomiModel());
const jsonData = ref(new sendToLoanHomiModelJsonData());

const addSendTLoanHomiForm = ref({
  LoanProductId: null,
  term: null,
  country: null,
  state: null,
  city: null,
  street: null,
  postalCode: null,
  totalSystemCost: null,
  downpaymentAmount: null,
  loanAmount: null,
  ownthePropertyID: null,
  CoPHousingStatus: null,
  CoHousingStatus: null,
  noOfMortgages: null,
  installerRepNameId: null,
  firstName: null,
  lastName: null,
  phone: null,
  mobile: null,
  email: null,
  ssn: null,
  dateofBirth: null,
  yearsAtCurrentResidence: null,
  monthsatCurrentResidence: null,
  yearsAtPreviousResidence: null,
  monthsatPreviousResidence: null,
  PRcountry: null,
  PRstate: null,
  PRCity: null,
  PRStreet: null,
  PRPostalCode: null,
  PHousingStatus: null,
  employementTypeID: null,
  employerName: null,
  occupation: null,
  yearsAtCurrentEmployement: null,
  monthsAtCurrentEmployement: null,
  lstIncomeFrequencyID: null,
  income: null,
  otherIncomeFrequencyID: null,
  otherIncome: null,
  otherIncomeSource: null,
  grossIncome: null,
  coApp_firstName: null,
  coApp_lastName: null,
  coApp_phone: null,
  coApp_mobile: null,
  coApp_email: null,
  coApp_ssn: null,
  coApp_dateofBirth: null,
  coApp_country: null,
  coAppstate: null,
  coApp_city: null,
  coApp_street: null,
  coApp_postalCode: null,
  coApp_occupation: null,
  coApp_yearsAtCurrentEmployement: null,
  coApp_monthsAtCurrentEmployement: null,
  employementType: null,
  coApp_employerName: null,
  coApp_incomeFrequency: null,
  coApp_income: null,
  coApp_otherIncomeFrequency: null,
  coApp_otherIncome: null,
  coApp_otherIncomeSource: null,
  coApp_grossIncome: null,
  isAutoPaymentcheckBox: true,
  isTermCheckBox: null,
  isBorrowers: null,
  coApp_employementTypeID: null,
  previousEmployerName: null,
  previousOccupation: null,
  yearsAtPreviousEmployement: null,
  monthsAtPreviousEmployement: null,
  coApp_previousEmployerName: null,
  coApp_previousOccupation: null,
  coApp_yearsAtCurrentResidence: null,
  coApp_monthsAtCurrentResidence: null,
  coApp_yearsAtPreviousResidence: null,
  coApp_monthsatPreviousResidence: null,
  coApp_PRcountry: null,
  coApp_PRstate: null,
  coApp_PRCity: null,
  coApp_PRStreet: null,
  coApp_PRPostalCode: null,
  coApp_yearsAtPreviousEmployement: null,
  coApp_monthsAtPreviousEmployement: null,
  installAgreement: [""],
  file: "",
  filename: [""],
  fileInputValue: null,
  IsCoApplicantRequired: false,
  sameAsapplicant: false,
});
const toaster = createToaster({ position: "top-right" });
const sendToLoanHomiPreviewDetail = ref(null);
const initialState = () => {
  return {
    LoanProductId: null,
    term: null,
    country: null,
    state: null,
    city: null,
    street: null,
    postalCode: null,
    totalSystemCost: null,
    downpaymentAmount: null,
    loanAmount: null,
    ownthePropertyID: null,
    CoPHousingStatus: null,
    CoHousingStatus: null,
    noOfMortgages: null,
    installerRepNameId: null,
    firstName: null,
    lastName: null,
    phone: null,
    mobile: null,
    email: null,
    ssn: null,
    dateofBirth: null,
    yearsAtCurrentResidence: null,
    monthsatCurrentResidence: null,
    yearsAtPreviousResidence: null,
    monthsatPreviousResidence: null,
    PRcountry: null,
    PRstate: null,
    PRCity: null,
    PRStreet: null,
    PRPostalCode: null,
    PHousingStatus: null,
    employementTypeID: null,
    employerName: null,
    occupation: null,
    yearsAtCurrentEmployement: null,
    monthsAtCurrentEmployement: null,
    lstIncomeFrequencyID: null,
    income: null,
    otherIncomeFrequencyID: null,
    otherIncome: null,
    otherIncomeSource: null,
    grossIncome: null,
    coApp_firstName: null,
    coApp_lastName: null,
    coApp_phone: null,
    coApp_mobile: null,
    coApp_email: null,
    coApp_ssn: null,
    coApp_dateofBirth: null,
    coApp_country: null,
    coAppstate: null,
    coApp_city: null,
    coApp_street: null,
    coApp_postalCode: null,
    coApp_occupation: null,
    coApp_yearsAtCurrentEmployement: null,
    coApp_monthsAtCurrentEmployement: null,
    employementType: null,
    coApp_employerName: null,
    coApp_incomeFrequency: null,
    coApp_income: null,
    coApp_otherIncomeFrequency: null,
    coApp_otherIncome: null,
    coApp_otherIncomeSource: null,
    coApp_grossIncome: null,
    isAutoPaymentcheckBox: true,
    isTermCheckBox: null,
    isBorrowers: null,
    coApp_employementTypeID: null,
    previousEmployerName: null,
    previousOccupation: null,
    yearsAtPreviousEmployement: null,
    monthsAtPreviousEmployement: null,
    coApp_previousEmployerName: null,
    coApp_previousOccupation: null,
    coApp_yearsAtCurrentResidence: null,
    coApp_monthsAtCurrentResidence: null,
    coApp_yearsAtPreviousResidence: null,
    coApp_monthsatPreviousResidence: null,
    coApp_PRcountry: null,
    coApp_PRstate: null,
    coApp_PRCity: null,
    coApp_PRStreet: null,
    coApp_PRPostalCode: null,
    coApp_yearsAtPreviousEmployement: null,
    coApp_monthsAtPreviousEmployement: null,
    installAgreement: [""],
    file: "",
    filename: [""],
    fileInputValue: null,
    IsCoApplicantRequired: false,
    sameAsapplicant: false
  }
}
const showAddSendTLoanHomiForm = ref(true);
const showPreviewSendTLoanHomiForm = ref(false);
const resultData = ref([]);
const selectedOwnTheProperty = ref(null);
const defaultOwnTheProperty = ref(null);
const iFreqYear = ref(null);
const iFreqYearValue = ref(null);
const iFreqMonth = ref(null);
const iFreqMonthValue = ref(null);
const rDataLoanAppId = ref(null);
const creditScoreCategory = ref(null);
const mandatoryDocuments = ref(null);
const rUserName = ref(null);
const IncomeVerificationValue = ref(null);
const TotalloanAmount = ref(null);
const focusvalidateFields = ref(null);
const value = ref(null);
const dotCount = ref(null);
const checkNumberOnly = ref(null);
const checkString = ref(null);
const format = ref("2.0-2");
const result = ref(null);
const fileName = ref("Install Agreement");
const type = ref(null);
const isValid = ref(true);
const dealerName = ref(null);
const DownpaymentAmount = ref(null);
const companyLogo = ref(null);
const companyName = ref(null);
const menulist = ref(null);
const imageLink = ref("");
const disbaleSubmitBtn = ref(null);
const disablePrevSubmitBtn = ref(null);
const fileInput1 = ref(null);
const loanAppId = ref(null);
const accountId = ref(null);
const showValidationIconOnPR = ref(false);
const showValidationIconOnCo_PR = ref(false);
const showValidationIconOn_income = ref(false);
const showValidationIconOn_coApp_income = ref(false);
const defaultCountry = ref(null);
const dpAmtValidation = ref(false);
const tscAmtValidation = ref(false);
const AutoPaymentStatus = ref(null);
const isSSNValidate = ref(false);
const isInvalidEmail = ref(false);
const dealerAccountId = ref(null);
const dealerCompanyId = ref(null);
const fileTypesGroup = ref(null);
const fileSize = ref(5);
const fileExtension = ref("");
const currencyFormat = ref("$");
const dateFormat = ref(null);
const locale = ref(localStorage.getItem("defaultLocale"));
const route = useRoute();
const lstownthePropertyCode = ref(null);
const companyId = ref(null);
const userId = ref(null);
const state = ref(null);
const isshowresponse = ref(false);
const isshowwarning = ref(false);
const isFileExtensionValid = ref(true);
const isFileValid = ref(true);
const loanProductList = ref([]);
const fileInput = ref(null);
const previousEmployerNamedisable = ref(true);
const previousOccupationdisable = ref(true);
const yearsAtPreviousEmployementdisable = ref(true);
const monthsAtPreviousEmployementdisable = ref(true);
const coApp_previousEmployerNamedisable = ref(true);
const coApp_previousOccupationdisable = ref(true);
const coApp_yearsAtPreviousEmployementdisable = ref(true);
const coApp_monthsAtPreviousEmployementdisable = ref(true)
const yearsAtPreviousResidencedisable = ref(true)
const monthsatPreviousResidencedisable = ref(true)
const PRcountrydisable = ref(true)
const PRstatedisable = ref(true)
const PRCitydisable = ref(true)
const PRStreetdisable = ref(true)
const PRPostalCodedisable = ref(true)
const CoPHousingStatusdisable = ref(true)
const PHousingStatusdisable = ref(true)
const incomedisable = ref(true);
const coApp_incomedisable = ref(true);
const otherIncomedisable = ref(true);
const coApp_otherIncomedisable = ref(true);

const loanApplicantRule = ref({
  LoanProductId: { required },
  state: { required },
  totalSystemCost: { required },
  noOfMortgages: { required },
  installerRepNameId: { required },
  firstName: { required },
  lastName: { required },
  mobile: { required },
  email: { required, email },
  ssn: { required },
  dateofBirth: { required },
  yearsAtCurrentResidence: { required },
  monthsatCurrentResidence: { required },
  employementTypeID: { required },
  lstIncomeFrequencyID: { required },
  income: { required },
  isTermCheckBox: { required },
  isBorrowers: { required },
  fileInputValue: { required }
});

const loanCoApplicantRule = ref({
  coApp_firstName: { required },
  coApp_lastName: { required },
  coApp_mobile: { required },
  coApp_email: { required },
  coApp_ssn: { required },
  coApp_dateofBirth: { required },
  coApp_country: { required },
  coAppstate: { required },
  coApp_city: { required },
  coApp_street: { required },
  coApp_postalCode: { required },
  coApp_occupation: { required },
  employementType: { required },
  coApp_employerName: { required },
  coApp_incomeFrequency: { required },
  coApp_income: { required },
  coApp_grossIncome: { required },
  coApp_employementTypeID: { required },
  coApp_yearsAtCurrentResidence: { required },
  coApp_monthsAtCurrentResidence: { required },
  CoHousingStatus: { required },
  coApp_yearsAtCurrentEmployement: { required },
  coApp_monthsAtCurrentEmployement: { required },
});

const loanApplicantRules = computed(() => loanApplicantRule.value);
const v$ = useVuelidate(loanApplicantRules, addSendTLoanHomiForm.value);

const loancoApplicantRules = computed(() => loanCoApplicantRule.value);
const vc$ = useVuelidate(loancoApplicantRules, addSendTLoanHomiForm.value);

//============================================================== functions =======================================================================//

const getUserInfo = () => {
  userId.value = localStorage.getItem("userId");
  companyId.value = localStorage.getItem("companyId");
};

const GetOwnThePropertyDll = () => {
  isLoading.value = true;
  lstownthePropertyCode.value = "OwntheProperty";
  commonService.value
    .GetMasterItemsNotAuthLoanProduct("OwntheProperty", null, userId.value, companyId.value)
    .then((result) => {
      isLoading.value = false
      if (result.data.length > 0) {
        lstowntheProperty.value = result.data;
        selectedOwnTheProperty.value = lstowntheProperty.value.filter(
          (x) => x.text == "YES"
        );
        defaultOwnTheProperty.value = selectedOwnTheProperty.value[0].value;
      }
    });
};

const GetPrevHousingStatus = () => {
  isLoading.value = true;
  commonService.value
    .GetMasterItemsNotAuthLoanProduct("PrevHousingStatus", null, userId.value, companyId.value)
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        lstprevHousingStatus.value = result.data;
      }
    });
};

const GetCurrendHousingStatus = () => {
  isLoading.value = true;
  commonService.value
    .GetMasterItemsNotAuthLoanProduct("CurrentHousingStatus", null, userId.value, companyId.value)
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        lstCurrHousingStatus.value = result.data;
      }
    });
};

const GetEmployementTypeDll = () => {
  isLoading.value = true;
  lstemployementTypeCode.value = "EmploymentType";
  commonService.value
    .GetMasterItemsNotAuthLoanProduct("EmploymentType", null, userId.value, companyId.value)
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        lstemployementType.value = result.data;
      }
    });
};

const getLoanProductList = () => {
  isLoading.value = true;
  lstemployementTypeCode.value = "LoanProduct";
  commonService.value
    .GetMasterItemsNotAuthLoanProduct(
      "LoanProduct",
      null,
      userId.value,
      dealerCompanyId.value
    )
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        loanProductList.value = result.data;
      }
    });
  isLoading.value = true;
  commonService.value
    .GetMasterItemsNotAuthLoanProduct(
      "CompanyLogo",
      null,
      userId.value,
      dealerCompanyId.value
    )
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        imageLink.value = result.data[0].text;
      }
    });
};

const getAccountNameById = () => {
  isLoading.value = true;
  loanApplicationService.value
    .getAccountNameById(dealerAccountId.value)
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        dealerName.value = result.data;
      }
    });
};



const getInstallerRepNameList = () => {
  isLoading.value = true;
  loanApplicationService.value
    .getInstallerRepNameList(
      dealerName.value,
      dealerAccountId.value,
      dealerCompanyId.value
    )
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        installerRepNameList.value = result.data;
        companyLogo.value = installerRepNameList.value[0].name;
        companyName.value = installerRepNameList.value[0].masterName;
      }
    });
};



const GetIncomeFrequencyDll = () => {
  isLoading.value = true;
  lstIncomeFrequencyCode.value = "IncomeFrequency";
  commonService.value
    .GetMasterItemsNotAuth("IncomeFrequency", userId.value, null)
    .then((result) => {
      isLoading.value = false;
      if (result.data.length > 0) {
        lstIncomeFrequency.value = result.data;
        iFreqYear.value = lstIncomeFrequency.value.filter((x) => x.text == "Annually");
        iFreqYearValue.value = iFreqYear.value[0].value;
        iFreqMonth.value = lstIncomeFrequency.value.filter((x) => x.text == "Monthly");
        iFreqMonthValue.value = iFreqMonth.value[0].value;
      }
    });
};



const getCountryDropdownList = () => {
  isLoading.value = true;
  commonService.value.getCountryListNotAuth().then((result) => {
    if (result.data.length > 0) {
      isLoading.value = false;
      countryLists.value = result.data;
      defaultCountry.value = countryLists.value.filter((x) => x.text == "United States");
      defaultCountry.value = defaultCountry.value[0].value;
      state.value = null;
      if (typeof defaultCountry.value !== "undefined" && defaultCountry.value !== null) {
        getStatesByCountry(defaultCountry.value, "first");
      }
    }
  });
};



const onClearCountry = (countryId, calltype) => {
  isLoading.value = true;
  if (calltype == "first") {
    state.value = null;
    states.value = [];
  }
  if (calltype == "second") {
    PRstate.value = null;
    statesII.value = [];
  }
  if (calltype == "third") {
    coAppstate = null;
    statesIII = [];
  }
  if (calltype == "four") {
    coApp_PRstate.value = null;
    statesIV.value = [];
  }
  isLoading.value = false;
};



const onCountryChange = (countryId, calltype) => {
  if (calltype == "first") {
    state.value = null;
  } else if (calltype == "second") {
    PRstate.value = null;
  } else if (calltype == "third") {
    coAppstate.value = null;
  } else if (calltype == "four") {
    coApp_PRstate.value = null;
  }
  if (typeof countryId !== "undefined" && countryId !== null) {
    getStatesByCountry(countryId, calltype);
  }
};



const getcompanyName = (countryId) => {
  isLoading.value = true;
  if (countryId != null) {
    commonService.value.GetCompanyName(countryId).then((result) => {
      if (result != null) {
        isLoading.value = false;
        companyName.value = result.data;
      }
    });
  }
};


const getStatesByCountry = (countryId, calltype) => {
  isLoading.value = true;
  let country = countryLists.value.find((x) => x.value == countryId);
  let code = country != null ? country.isoCode : "";

  if (calltype == "first") {
    addSendTLoanHomiForm.value.state = null;
    commonService.value.getStatesList_V1(countryId).then((res) => {
      states.value = res.data;
    });
  }
  if (calltype == "second") {
    addSendTLoanHomiForm.value.PRstate = null;
    commonService.value.getStatesList_V1(countryId).then((res) => {
      statesII.value = res.data;
    });
  }
  if (calltype == "third") {
    addSendTLoanHomiForm.value.coAppstate = null;
    commonService.value.getStatesList_V1(countryId).then((res) => {
      statesIII.value = res.data;
    });
  }
  if (calltype == "four") {
    addSendTLoanHomiForm.value.coApp_PRstate = null;
    commonService.value.getStatesList_V1(countryId).then((res) => {
      statesIV.value = res.data;
    });
  }
  isLoading.value = false;
};



const getState = () => {
  isLoading.value = true;
  userService.value.getStateListNotAuth().then((result) => {
    isLoading.value = false;
    var data = result;
    states.value = data.filter(
      (x) =>
        x.text == "Arizona" ||
        x.text == "Washington" ||
        x.text == "Ohio" ||
        x.text == "Oregon" ||
        x.text == "Idaho"
    );
  });

};



//=======================================================================================================
const checkDuplicateEmail = (isCoApplicant) => {

  if (isCoApplicant == 0) {
    if (addSendTLoanHomiForm.value.email && addSendTLoanHomiForm.value.email != "") {
      isLoading.value = true;
      loanApplicationService.value
        .LoanApplicationContactCheck(
          addSendTLoanHomiForm.value.email,
          dealerCompanyId.value
        )
        .then((result) => {
          isLoading.value = false;
          if (result) {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
              question: t('CRMSetting.DuplicateContactQuestion'),
              header: t('CRMSetting.DuplicateContactHeader'),
              cancel: t('CRMSetting.CancelLabel'),
              confirm: t('CRMSetting.OkLabel'),
            });
            onConfirm(() => {
              addSendTLoanHomiForm.value.country = result.Country;
              addSendTLoanHomiForm.value.state = result.State;
              addSendTLoanHomiForm.value.city = result.City;
              addSendTLoanHomiForm.value.street = result.Street;
              addSendTLoanHomiForm.value.postalCode = result.PostalCode;
              addSendTLoanHomiForm.value.firstName = result.FirstName;
              addSendTLoanHomiForm.value.lastName = result.LastName;
              addSendTLoanHomiForm.value.mobile = result.MobilePhone;
              addSendTLoanHomiForm.value.phone = result.Phone;
            });
            reveal(() => {
              addSendTLoanHomiForm.value.email = null;
              isLoading.value = false;
            });
          }
        });
    }
  } else {
    if (
      addSendTLoanHomiForm.value.coApp_email &&
      addSendTLoanHomiForm.value.coApp_email != ""
    ) {
      isLoading.value = true;
      loanApplicationService.value
        .LoanApplicationContactCheck(
          addSendTLoanHomiForm.value.coApp_email,
          dealerCompanyId.value
        )
        .then((result) => {
          if (result) {
            isLoading.value = false;
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
              question: t('CRMSetting.DuplicateContactQuestion'),
              header: t('CRMSetting.DuplicateContactHeader'),
              cancel: t('CRMSetting.CancelLabel'),
              confirm: t('CRMSetting.OkLabel'),
            });
            onConfirm(() => {
              addSendTLoanHomiForm.value.coApp_country = Number(result.Country);
              addSendTLoanHomiForm.value.coAppstate = Number(result.State);
              addSendTLoanHomiForm.value.coApp_city = result.City;
              addSendTLoanHomiForm.value.coApp_street = result.Street;
              addSendTLoanHomiForm.value.coApp_postalCode = result.PostalCode;
              addSendTLoanHomiForm.value.coApp_firstName = result.FirstName;
              addSendTLoanHomiForm.value.coApp_lastName = result.LastName;
              addSendTLoanHomiForm.value.coApp_mobile = result.MobilePhone;
              addSendTLoanHomiForm.value.coApp_phone = result.Phone;
            });
            reveal(() => {
              addSendTLoanHomiForm.value.coApp_email = null;
              isLoading.value = false;
            });
          }
        });
    }
  }
};


const onSubmit = () => {
  disbaleSubmitBtn.value = true;
  disablePrevSubmitBtn.value = true;

  v$.value.$validate();
  vc$.value.$validate();
  console.log(v$.value.$error);
  if (v$.value.$error) {
    return false;
  } else if (vc$.value.$error && addSendTLoanHomiForm.IsCoApplicantRequired == true)
    return false;
  else {
    if (addSendTLoanHomiForm.value) {
      loanApplicationService.value
        .CheckBankDocumentMapping(
          dealerCompanyId.value,
          addSendTLoanHomiForm.value.LoanProductId
        )
        .then((result) => {
          if (result.data.statusCode != 200) {
            toaster.error(t(`CRMSetting.${result.data.responseMessage}`));
          }
          else {
            isLoading.value = true;
            sendToLoanHomiDataModel.value.DealerName = dealerName.value;
            sendToLoanHomiDataModel.value.DealerAccountId = dealerAccountId.value;
            sendToLoanHomiDataModel.value.LoanProductId =
              addSendTLoanHomiForm.value.LoanProductId;
            sendToLoanHomiDataModel.value.InstallerRepNameId =
              addSendTLoanHomiForm.value.installerRepNameId;
            sendToLoanHomiDataModel.value.InstallerRepName = installerRepNameList.value.find(
              (x) => (x.value = addSendTLoanHomiForm.value.installerRepNameId)
            ).text;
            sendToLoanHomiDataModel.value.Term = addSendTLoanHomiForm.value.term;
            sendToLoanHomiDataModel.value.country = addSendTLoanHomiForm.value.country;
            sendToLoanHomiDataModel.value.BillingState = addSendTLoanHomiForm.value.state;
            sendToLoanHomiDataModel.value.BillingCity = addSendTLoanHomiForm.value.city;
            sendToLoanHomiDataModel.value.MailingState = addSendTLoanHomiForm.value.state;
            sendToLoanHomiDataModel.value.MailingCity = addSendTLoanHomiForm.value.city;
            sendToLoanHomiDataModel.value.BillingStreet = addSendTLoanHomiForm.value.street;
            sendToLoanHomiDataModel.value.BillingPostalCode =
              addSendTLoanHomiForm.value.postalCode;
            sendToLoanHomiDataModel.value.Total_System_Cost =
              addSendTLoanHomiForm.value.totalSystemCost;
            sendToLoanHomiDataModel.value.Downpayment_Amount =
              addSendTLoanHomiForm.value.downpaymentAmount;
            sendToLoanHomiDataModel.value.Loan_Amount =
              addSendTLoanHomiForm.value.loanAmount;
            sendToLoanHomiDataModel.value.Owntheproperty =
              addSendTLoanHomiForm.value.ownthePropertyID;
            sendToLoanHomiDataModel.value.NoofMortgages =
              addSendTLoanHomiForm.value.noOfMortgages;
            sendToLoanHomiDataModel.value.FirstName = addSendTLoanHomiForm.value.firstName;
            sendToLoanHomiDataModel.value.LastName = addSendTLoanHomiForm.value.lastName;
            sendToLoanHomiDataModel.value.Phone = addSendTLoanHomiForm.value.phone;
            sendToLoanHomiDataModel.value.MobilePhone = addSendTLoanHomiForm.value.mobile;
            sendToLoanHomiDataModel.value.Email = addSendTLoanHomiForm.value.email;
            sendToLoanHomiDataModel.value.SSN = addSendTLoanHomiForm.value.ssn;
            sendToLoanHomiDataModel.value.DOB = addSendTLoanHomiForm.value.dateofBirth; //addSendTLoanHomiForm.value.dateofBirth
            sendToLoanHomiDataModel.value.YearsACA =
              addSendTLoanHomiForm.value.yearsAtCurrentResidence;
            sendToLoanHomiDataModel.value.MonthsACA =
              addSendTLoanHomiForm.value.monthsatCurrentResidence;
            sendToLoanHomiDataModel.value.PYearACR =
              addSendTLoanHomiForm.value.yearsAtPreviousResidence;
            sendToLoanHomiDataModel.value.PMonthACR =
              addSendTLoanHomiForm.value.monthsatPreviousResidence;
            sendToLoanHomiDataModel.value.PRcountry = addSendTLoanHomiForm.value.PRcountry;
            sendToLoanHomiDataModel.value.PRstate = addSendTLoanHomiForm.value.PRstate;
            sendToLoanHomiDataModel.value.PRCity = addSendTLoanHomiForm.value.PRCity;
            sendToLoanHomiDataModel.value.PRStreet = addSendTLoanHomiForm.value.PRStreet;
            sendToLoanHomiDataModel.value.PRPostalCode =
              addSendTLoanHomiForm.value.PRPostalCode;
            sendToLoanHomiDataModel.value.PHousingStatus =
              addSendTLoanHomiForm.value.PHousingStatus;
            sendToLoanHomiDataModel.value.EmployerType =
              addSendTLoanHomiForm.value.employementTypeID;
            sendToLoanHomiDataModel.value.Employer =
              addSendTLoanHomiForm.value.employerName;
            sendToLoanHomiDataModel.value.YearsACE =
              addSendTLoanHomiForm.value.yearsAtCurrentEmployement;
            sendToLoanHomiDataModel.value.MonthsACE =
              addSendTLoanHomiForm.value.monthsAtCurrentEmployement;
            sendToLoanHomiDataModel.value.PEmployerName =
              addSendTLoanHomiForm.value.previousEmployerName;
            sendToLoanHomiDataModel.value.POccupation =
              addSendTLoanHomiForm.value.previousOccupation;
            sendToLoanHomiDataModel.value.PYearsACE =
              addSendTLoanHomiForm.value.yearsAtPreviousEmployement;
            sendToLoanHomiDataModel.value.PMonthsACE =
              addSendTLoanHomiForm.value.monthsAtPreviousEmployement;
            sendToLoanHomiDataModel.value.IncomeFreq =
              addSendTLoanHomiForm.value.lstIncomeFrequencyID;
            sendToLoanHomiDataModel.value.Income = addSendTLoanHomiForm.value.income;
            sendToLoanHomiDataModel.value.OIncomeFreq =
              addSendTLoanHomiForm.value.otherIncomeFrequencyID;
            sendToLoanHomiDataModel.value.OIncomeMonthly =
              addSendTLoanHomiForm.value.otherIncome;
            sendToLoanHomiDataModel.value.OIncomeSource =
              addSendTLoanHomiForm.value.otherIncomeSource;
            sendToLoanHomiDataModel.value.GrossIncome =
              addSendTLoanHomiForm.value.grossIncome;
            sendToLoanHomiDataModel.value.Occupation =
              addSendTLoanHomiForm.value.occupation;
            sendToLoanHomiDataModel.value.coFirstname =
              addSendTLoanHomiForm.value.coApp_firstName;
            sendToLoanHomiDataModel.value.coLastname =
              addSendTLoanHomiForm.value.coApp_lastName;
            sendToLoanHomiDataModel.value.coPhone = addSendTLoanHomiForm.value.coApp_phone;
            sendToLoanHomiDataModel.value.coMobilePhone =
              addSendTLoanHomiForm.value.coApp_mobile;
            sendToLoanHomiDataModel.value.coEmail = addSendTLoanHomiForm.value.coApp_email;
            sendToLoanHomiDataModel.value.coSSN = addSendTLoanHomiForm.value.coApp_ssn;
            sendToLoanHomiDataModel.value.coDOB =
              addSendTLoanHomiForm.value.coApp_dateofBirth;
            sendToLoanHomiDataModel.value.coApp_country =
              addSendTLoanHomiForm.value.coApp_country;
            sendToLoanHomiDataModel.value.coMailingState =
              addSendTLoanHomiForm.value.coAppstate;
            sendToLoanHomiDataModel.value.coMailingCity =
              addSendTLoanHomiForm.value.coApp_city;
            sendToLoanHomiDataModel.value.coMailingStreet =
              addSendTLoanHomiForm.value.coApp_street;
            sendToLoanHomiDataModel.value.coMailingPostalCode =
              addSendTLoanHomiForm.value.coApp_postalCode;
            sendToLoanHomiDataModel.value.coOccupation =
              addSendTLoanHomiForm.value.coApp_occupation;
            sendToLoanHomiDataModel.value.coYearsACE =
              addSendTLoanHomiForm.value.coApp_yearsAtCurrentEmployement;
            sendToLoanHomiDataModel.value.coMonthsACE =
              addSendTLoanHomiForm.value.coApp_monthsAtCurrentEmployement;
            sendToLoanHomiDataModel.value.coEmployerType =
              addSendTLoanHomiForm.value.coApp_employementTypeID;
            sendToLoanHomiDataModel.value.coEmployer =
              addSendTLoanHomiForm.value.coApp_employerName;
            sendToLoanHomiDataModel.value.coIncomeFreq =
              addSendTLoanHomiForm.value.coApp_incomeFrequency;
            sendToLoanHomiDataModel.value.CoIncome =
              addSendTLoanHomiForm.value.coApp_income;
            sendToLoanHomiDataModel.value.CoOIncomeFreq =
              addSendTLoanHomiForm.value.coApp_otherIncomeFrequency;
            sendToLoanHomiDataModel.value.coOIncome =
              addSendTLoanHomiForm.value.coApp_otherIncome;
            sendToLoanHomiDataModel.value.coOIncomeSource =
              addSendTLoanHomiForm.value.coApp_otherIncomeSource;
            sendToLoanHomiDataModel.value.coGrossIncome =
              addSendTLoanHomiForm.value.coApp_grossIncome;

            if (addSendTLoanHomiForm.value.IsCoApplicantRequired == null) {
              sendToLoanHomiDataModel.value.Iscoapplicant = false;
            } else {
              sendToLoanHomiDataModel.value.Iscoapplicant =
                addSendTLoanHomiForm.value.IsCoApplicantRequired;
            }
            sendToLoanHomiDataModel.value.AutoPayment =
              addSendTLoanHomiForm.value.isAutoPaymentcheckBox;

            if (
              sendToLoanHomiDataModel.value.CustomerSignedDate == null ||
              sendToLoanHomiDataModel.value.CustomerSignedDate == ""
            ) {
              sendToLoanHomiDataModel.value.IsDocsSigned = 0;
            } else {
              sendToLoanHomiDataModel.value.IsDocsSigned = 1;
            }

            sendToLoanHomiDataModel.value.CompanyId = dealerCompanyId.value;
            sendToLoanHomiDataModel.value.isBorrowers =
              addSendTLoanHomiForm.value.isBorrowers == "" ? false : true;
            sendToLoanHomiDataModel.value.coPEmployerName =
              addSendTLoanHomiForm.value.coApp_previousEmployerName;
            sendToLoanHomiDataModel.value.coPOccupation =
              addSendTLoanHomiForm.value.coApp_previousOccupation;
            sendToLoanHomiDataModel.value.coPYearsACE =
              addSendTLoanHomiForm.value.coApp_yearsAtPreviousEmployement;
            sendToLoanHomiDataModel.value.coPMonthsACE =
              addSendTLoanHomiForm.value.coApp_monthsAtPreviousEmployement;
            sendToLoanHomiDataModel.value.coYearsACA =
              addSendTLoanHomiForm.value.coApp_yearsAtCurrentResidence;
            sendToLoanHomiDataModel.value.coMonthsACA =
              addSendTLoanHomiForm.value.coApp_monthsAtCurrentResidence;
            sendToLoanHomiDataModel.value.coPYearACR =
              addSendTLoanHomiForm.value.coApp_yearsAtPreviousResidence;
            sendToLoanHomiDataModel.value.coPMonthACR =
              addSendTLoanHomiForm.value.coApp_monthsatPreviousResidence;
            sendToLoanHomiDataModel.value.coPRcountry =
              addSendTLoanHomiForm.value.coApp_PRcountry;
            sendToLoanHomiDataModel.value.coPRstate =
              addSendTLoanHomiForm.value.coApp_PRstate;
            sendToLoanHomiDataModel.value.coPRCity =
              addSendTLoanHomiForm.value.coApp_PRCity;
            sendToLoanHomiDataModel.value.coPRStreet =
              addSendTLoanHomiForm.value.coApp_PRStreet;
            sendToLoanHomiDataModel.value.coPRPostalCode =
              addSendTLoanHomiForm.value.coApp_PRPostalCode;
            sendToLoanHomiDataModel.value.CoPHousingStatus =
              addSendTLoanHomiForm.value.CoPHousingStatus;
            sendToLoanHomiDataModel.value.CoHousingStatus =
              addSendTLoanHomiForm.value.CoHousingStatus;
            sendToLoanHomiDataModel.value.OppOwnerId =
              addSendTLoanHomiForm.value.installerRepNameId;
            sendToLoanHomiDataModel.value.CreatedBy =
              addSendTLoanHomiForm.value.installerRepNameId;
            sendToLoanHomiDataModel.value.UserId =
              userId.value

            sendToLoanHomiPreviewDetail.value = sendToLoanHomiDataModel.value;

            if (
              sendToLoanHomiPreviewDetail.value.LoanProductId != null &&
              sendToLoanHomiPreviewDetail.value.LoanProductId != 0
            ) {
              let valLoanProduct;
              valLoanProduct = loanProductList.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.LoanProductId
              );
              sendToLoanHomiPreviewDetail.value.LoanProductId = valLoanProduct[0].text;
            }
            if (
              sendToLoanHomiPreviewDetail.value.country != null &&
              sendToLoanHomiPreviewDetail.value.country != 0
            ) {
              let valcountry;
              valcountry = countryLists.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.country
              );
              sendToLoanHomiPreviewDetail.value.country = valcountry[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coApp_country != null &&
              sendToLoanHomiPreviewDetail.value.coApp_country != 0
            ) {
              let valcoApp_country;
              valcoApp_country = countryLists.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coApp_country
              );
              sendToLoanHomiPreviewDetail.value.coApp_country = valcoApp_country[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.BillingState != null &&
              sendToLoanHomiPreviewDetail.value.BillingState != 0
            ) {
              let valstate;
              valstate = states.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.BillingState
              );
              sendToLoanHomiPreviewDetail.value.BillingState = valstate[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coMailingState != null &&
              sendToLoanHomiPreviewDetail.value.coMailingState != 0
            ) {
              let valcostate;
              valcostate = states.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coMailingState
              );
              sendToLoanHomiPreviewDetail.value.coMailingState = valcostate[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.Owntheproperty != null &&
              sendToLoanHomiPreviewDetail.value.Owntheproperty != 0
            ) {
              let valOwntheProperty;
              valOwntheProperty = lstowntheProperty.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.Owntheproperty
              );
              sendToLoanHomiPreviewDetail.value.Owntheproperty = valOwntheProperty[0].text;
            }
            if (
              sendToLoanHomiPreviewDetail.value.EmployerType != null &&
              sendToLoanHomiPreviewDetail.value.EmployerType != 0
            ) {
              sendToLoanHomiPreviewDetail.value.EmployerType = lstemployementType.value.find(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.EmployerType
              ).text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.IncomeFreq != null &&
              sendToLoanHomiPreviewDetail.value.IncomeFreq != 0
            ) {
              let valIncomeFreq;
              valIncomeFreq = lstIncomeFrequency.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.IncomeFreq
              );
              sendToLoanHomiPreviewDetail.value.IncomeFreq = valIncomeFreq[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.OIncomeFreq != null &&
              sendToLoanHomiPreviewDetail.value.OIncomeFreq != 0
            ) {
              let valOIncomeFreq;
              valOIncomeFreq = lstIncomeFrequency.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.OIncomeFreq
              );
              sendToLoanHomiPreviewDetail.value.OIncomeFreq = valOIncomeFreq[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coIncomeFreq != null &&
              sendToLoanHomiPreviewDetail.value.coIncomeFreq != 0
            ) {
              let valcoIncomeFreq;
              valcoIncomeFreq = lstIncomeFrequency.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coIncomeFreq
              );
              sendToLoanHomiPreviewDetail.value.coIncomeFreq = valcoIncomeFreq[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.CoOIncomeFreq != null &&
              sendToLoanHomiPreviewDetail.value.CoOIncomeFreq != 0
            ) {
              let valCoOIncomeFreq;
              valCoOIncomeFreq = lstIncomeFrequency.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.CoOIncomeFreq
              );
              sendToLoanHomiPreviewDetail.value.CoOIncomeFreq = valCoOIncomeFreq[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coEmployerType != null &&
              sendToLoanHomiPreviewDetail.value.coEmployerType != 0
            ) {
              sendToLoanHomiPreviewDetail.value.coEmployerType = lstemployementType.value.find(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coEmployerType
              ).text;
            }
            if (
              sendToLoanHomiPreviewDetail.value.PRcountry != null &&
              sendToLoanHomiPreviewDetail.value.PRcountry != 0
            ) {
              let valPRcountry;
              valPRcountry = countryLists.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.PRcountry
              );
              sendToLoanHomiPreviewDetail.value.PRcountry = valPRcountry[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.PRstate != null &&
              sendToLoanHomiPreviewDetail.value.PRstate != 0
            ) {
              let valPRstate;
              valPRstate = states.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.PRstate
              );
              sendToLoanHomiPreviewDetail.value.PRstate = valPRstate[0].text;
            }
            if (
              sendToLoanHomiPreviewDetail.value.PHousingStatus != null &&
              sendToLoanHomiPreviewDetail.value.PHousingStatus != 0
            ) {
              let valPHousingStatus;
              valPHousingStatus = lstprevHousingStatus.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.PHousingStatus
              );
              sendToLoanHomiPreviewDetail.value.PHousingStatus = valPHousingStatus[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coPRcountry != null &&
              sendToLoanHomiPreviewDetail.value.coPRcountry != 0
            ) {
              let valcoPRcountry;
              valcoPRcountry = countryLists.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coPRcountry
              );
              sendToLoanHomiPreviewDetail.value.coPRcountry = valcoPRcountry[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.coPRstate != null &&
              sendToLoanHomiPreviewDetail.value.coPRstate != 0
            ) {
              let valcoPRstate;
              valcoPRstate = states.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.coPRstate
              );
              sendToLoanHomiPreviewDetail.value.coPRstate = valcoPRstate[0].text;
            }
            if (
              sendToLoanHomiPreviewDetail.value.CoPHousingStatus != null &&
              sendToLoanHomiPreviewDetail.value.CoPHousingStatus != 0
            ) {
              let valCoPHousingStatus;
              valCoPHousingStatus = lstprevHousingStatus.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.CoPHousingStatus
              );
              sendToLoanHomiPreviewDetail.value.CoPHousingStatus =
                valCoPHousingStatus[0].text;
            }

            if (
              sendToLoanHomiPreviewDetail.value.CoHousingStatus != null &&
              sendToLoanHomiPreviewDetail.value.CoHousingStatus != 0
            ) {
              let valCoHousingStatus;
              valCoHousingStatus = lstCurrHousingStatus.value.filter(
                (x) => x.value == sendToLoanHomiPreviewDetail.value.CoHousingStatus
              );
              sendToLoanHomiPreviewDetail.value.CoHousingStatus =
                valCoHousingStatus[0].text;
            }

            if (
              sendToLoanHomiDataModel.value.DOB != "" &&
              sendToLoanHomiDataModel.value.DOB != undefined &&
              sendToLoanHomiDataModel.value.DOB != null
            ) {
              debugger;
              sendToLoanHomiDataModel.value.DOBfView = sendToLoanHomiDataModel.value.DOB;
            }

            if (
              sendToLoanHomiDataModel.value.coDOB != "" &&
              sendToLoanHomiDataModel.value.coDOB != undefined &&
              sendToLoanHomiDataModel.value.coDOB != null
            ) {
              sendToLoanHomiDataModel.value.coDOBfView =
                sendToLoanHomiDataModel.value.coDOB;
            }

            if (
              sendToLoanHomiDataModel.value.Total_System_Cost != "" &&
              sendToLoanHomiDataModel.value.Total_System_Cost != undefined &&
              sendToLoanHomiDataModel.value.Total_System_Cost != null
            ) {
              sendToLoanHomiDataModel.value.Total_System_CostfView =
                sendToLoanHomiDataModel.value.Total_System_Cost;
            }

            if (
              sendToLoanHomiDataModel.value.Downpayment_Amount != "" &&
              sendToLoanHomiDataModel.value.Downpayment_Amount != undefined &&
              sendToLoanHomiDataModel.value.Downpayment_Amount != null
            ) {
              sendToLoanHomiDataModel.value.Downpayment_AmountfView =
                sendToLoanHomiDataModel.value.Downpayment_Amount;
            }

            if (
              sendToLoanHomiDataModel.value.Loan_Amount != "" &&
              sendToLoanHomiDataModel.value.Loan_Amount != undefined &&
              sendToLoanHomiDataModel.value.Loan_Amount != null
            ) {
              sendToLoanHomiDataModel.value.Loan_AmountfView =
                sendToLoanHomiDataModel.value.Loan_Amount;
            }

            if (
              sendToLoanHomiDataModel.value.Income != "" &&
              sendToLoanHomiDataModel.value.Income != undefined &&
              sendToLoanHomiDataModel.value.Income != null
            ) {
              sendToLoanHomiDataModel.value.IncomefView =
                sendToLoanHomiDataModel.value.Income;
            }

            if (
              sendToLoanHomiDataModel.value.GrossIncome != "" &&
              sendToLoanHomiDataModel.value.GrossIncome != undefined &&
              sendToLoanHomiDataModel.value.GrossIncome != null
            ) {
              sendToLoanHomiDataModel.value.GrossIncomefView =
                sendToLoanHomiDataModel.value.GrossIncome;
            }

            if (
              sendToLoanHomiDataModel.value.CoIncome != "" &&
              sendToLoanHomiDataModel.value.CoIncome != undefined &&
              sendToLoanHomiDataModel.value.CoIncome != null
            ) {
              sendToLoanHomiDataModel.value.CoIncomefView =
                sendToLoanHomiDataModel.value.CoIncome;
            }

            if (
              sendToLoanHomiDataModel.value.coGrossIncome != "" &&
              sendToLoanHomiDataModel.value.coGrossIncome != undefined &&
              sendToLoanHomiDataModel.value.coGrossIncome != null
            ) {
              sendToLoanHomiDataModel.value.coGrossIncomefView =
                sendToLoanHomiDataModel.value.coGrossIncome;
            }

            if (sendToLoanHomiDataModel.value.OIncomeMonthly > 0) {
              sendToLoanHomiDataModel.value.OIncomeMonthlystr =
                sendToLoanHomiDataModel.value.OIncomeMonthly;
            }

            if (sendToLoanHomiPreviewDetail.value.AutoPayment == true) {
              AutoPaymentStatus.value = "Yes";
            }
            if (sendToLoanHomiPreviewDetail.value.AutoPayment == false) {
              AutoPaymentStatus.value = "No";
            }

            const input1 = new FormData();
            fileInput1.value = fileInput.value;
            showAddSendTLoanHomiForm.value = false;
            showPreviewSendTLoanHomiForm.value = true;
            isLoading.value = false
            window.scrollTo(0, 0);
          }
        });
    } else {
      for (const key of Object.keys(addSendTLoanHomiForm.controls)) {
        if (addSendTLoanHomiForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[v-model="' + key + '"]'
          );
          if (key == "LoanProductId") {
            loanproductSelect.value.filterInput.nativeElement.focus();
            break;
          } else if (key == "installerRepNameId") {
            installerSelect.value.filterInput.nativeElement.focus();
            break;
          } else if (key == "employementTypeID") {
            employeeSelect.value.filterInput.nativeElement.focus();
            break;
          } else if (key == "lstIncomeFrequencyID") {
            incomeSelect.value.filterInput.nativeElement.focus();
            break;
          } else if (key == "mobile") {
            invalidControl.children[0].focus();
            break;
          } else if (key == "dateofBirth") {
            dobdate.value.inputfieldViewChild.nativeElement.focus();
            break;
          } else if (key == "state") {
            State.value.filterInput.nativeElement.focus();
            break;
          } else {
            invalidControl.focus();
            break;
          }
        }
      }
    }
  }
  //=========================================================================================================
};

const onBack = () => {
  isLoading.value = true;
  showPreviewSendTLoanHomiForm.value = false;
  showAddSendTLoanHomiForm.value = true;
  window.scrollTo(0, 0);
  setTimeout(() => {
    isLoading.value = false;
  }, 4000);
};



const onPrevSubmit = async () => {
  disbaleSubmitBtn.value = false;
  disablePrevSubmitBtn.value = false;
  isLoading.value = true;
  sendToLoanHomiPreviewDetail.value.country = addSendTLoanHomiForm.value.country;
  sendToLoanHomiDataModel.value.coApp_country = addSendTLoanHomiForm.value.coApp_country;
  sendToLoanHomiDataModel.value.PRcountry = addSendTLoanHomiForm.value.PRcountry;
  sendToLoanHomiDataModel.value.coPRcountry = addSendTLoanHomiForm.value.coApp_PRcountry;
  sendToLoanHomiDataModel.value.BillingState = addSendTLoanHomiForm.value.state;
  sendToLoanHomiDataModel.value.coMailingState = addSendTLoanHomiForm.value.coAppstate;
  sendToLoanHomiPreviewDetail.value.PRstate = addSendTLoanHomiForm.value.PRstate;
  sendToLoanHomiPreviewDetail.value.PHousingStatus =
    addSendTLoanHomiForm.value.PHousingStatus;
  sendToLoanHomiPreviewDetail.value.coPRstate = addSendTLoanHomiForm.value.coApp_PRstate;
  sendToLoanHomiDataModel.value.LoanProductId = addSendTLoanHomiForm.value.LoanProductId;
  sendToLoanHomiDataModel.value.EmployerType =
    addSendTLoanHomiForm.value.employementTypeID;
  sendToLoanHomiDataModel.value.coEmployerType =
    addSendTLoanHomiForm.value.coApp_employementTypeID;
  sendToLoanHomiPreviewDetail.value.CoPHousingStatus =
    addSendTLoanHomiForm.value.CoPHousingStatus;
  sendToLoanHomiPreviewDetail.value.CoHousingStatus =
    addSendTLoanHomiForm.value.CoHousingStatus;
  jsonData.value.FormJsonData = JSON.stringify(sendToLoanHomiDataModel.value);


  await loanApplicationService.value.saveData(jsonData.value).then(
    (result) => {

      if (result.data == "" || result.data == null) {
        toaster.error(t('CRMSetting.SFAPI'));
        return false;
      }


      var resultdata = result.data;
      loanAppId.value = resultdata.loanAppAutoId;
      accountId.value = resultdata.accountId;
      rUserName.value = resultdata.userName;
      rDataLoanAppId.value = resultdata.loanAppId;
      creditScoreCategory.value = resultdata.creditScoreCategory;
      IncomeVerificationValue.value = resultdata.incomeVerificationValue;
      mandatoryDocuments.value = resultdata.mandatoryDocuments;


      //============Save Pdf File================================
      if (fileName.value != "Install Agreement") {
        let input = new FormData();
        input.append("refid", loanAppId.value);
        input.append("moduleid", "1800");
        input.append("submoduleid", "1810");
        input.append("filetype", "6702E35E-B7B1-4E48-AA98-FF6C012101E1");
        input.append("documentTitle", "InstallAgreement");
        input.append("accountid", accountId.value);
        input.append("CompanyId", companyId.value);
        input.append("UserId", userId.value);
        input.append("companyName", companyName.value);
        input.append("fileExtension", fileExtension.value);

        if (addSendTLoanHomiForm.value.fileInputValue != null) {
          input.append("file", addSendTLoanHomiForm.value.fileInputValue);
        }


        loanApplicationService.value
          .addOrUpdateUploadFileOnAzzureNoAuth(input)
          .then(
            (result) => {
              setTimeout(() => {
                if (result.data.statusCode == 200) {
                  fileName.value = "Install Agreement";
                  window.scrollTo(0, 0);
                } else {
                  toaster.error(t('CRMSetting.SomethingWentWrongPleaseContactAdministrator'));
                }
                // //this.loadSave = false;
              }, 3000);
            },
            (error) => {

              // //this.loadSave = false;
            }
          );
      }
      //=========================================================

      if (resultdata.code == null || resultdata.code == "") {
        toaster.error(t('CRMSetting.SomethingWentWrongPleaseContactAdministrator'));
        isLoading.value = false;
        return false;
      }

      if (resultdata.code != "Failure") {
        if (resultdata.applicationStatus == "Failed") {
          showPreviewSendTLoanHomiForm.value = false;
          Object.assign(addSendTLoanHomiForm.value, initialState());
          //addSendTLoanHomiForm.value.isAutoPaymentcheckBox.value = 1;
          //loanCoApplicantRule.value = null;
          //loanApplicantRule.value = null;
          showAddSendTLoanHomiForm.value = true;
          if (fileName.value != "Install Agreement") {
            fileName.value = "Install Agreement";
          }
          isshowresponse.value = false;
          isshowwarning.value = true;
          isLoading.value = false;
        } else {
          showPreviewSendTLoanHomiForm.value = false;
          v$.value.$reset();
          vc$.value.$reset();
          Object.assign(addSendTLoanHomiForm.value, initialState());
          //addSendTLoanHomiForm.value?.reset();
          //addSendTLoanHomiForm.isAutoPaymentcheckBox.value = null;
          showAddSendTLoanHomiForm.value = true;
          if (fileName.value != "Install Agreement") {
            fileName.value = "Install Agreement";
          }

          isshowwarning.value = false;
          isshowresponse.value = true
          isLoading.value = false;
        }
      } else {
        toaster.error(resultdata.statusCode);
        isLoading.value = false;
        return false;
      }
      isLoading.value = false;
    },
    (error) => {
      isLoading.value = false;
    }
  );
};



const checkAge = (control) => {
  var value = control.value;
  if (value != null && value != "") {
    let selectedDate = moment(value, "MM/DD/YYYY");
    var today = moment();
    let years = today.diff(selectedDate, "years");
    if (years < 18) {
      return { lessthan18: true };
    }
  } else {
    return { required: true };
  }
  return null;
};



const getConfigurationTypeFileExtensions = () => {
  isLoading.value = true;
  commonService.value
    .getConfigurationTypeFileExtensions("Install Agreement", companyId.value)
    .then((result) => {
      isLoading.value = false
      if (result && result.data.FileTypesGroup != "") {
        fileSize.value = result.data.FileSize;
        fileTypesGroup.value = JSON.parse(result.data.FileTypesGroup);
        fileTypesGroup.value = fileTypesGroup.value.filter(
          (x) => x.Name == "Image" || x.Name == "Document"
        );

        fileTypesGroup.value.forEach((obj, index) => {
          if (obj.FileTypes) {
            let extension = obj.FileTypes.map((x) => x.Name);
            fileExtension.value += index > 0 && fileExtension.value != "" ? ", " : "";
            fileExtension.value += extension.join(", ");
          }
        });
      }
    });
};



const allowPDF = ($event) => {
  validUploadDocumentType($event.target.files[0].name, $event.target.accept);
  validUploadDocumentSize($event.target.files[0].size, fileSize.value);
  if (isFileValid.value) {
    addSendTLoanHomiForm.value.fileInputValue = $event.target.files[0];
    console.log("file Data", addSendTLoanHomiForm.value.fileInputValue);
    fileName.value = $event.target.files[0].name;
    fileExtension.value = fileName.value.replace(/^.*\./, "");
  }
};



const validUploadDocumentType = (name, validType) => {
  let splitstr = name.toLowerCase().split(".").reverse();
  let ext = splitstr.length > 0 ? splitstr[0] : "";
  if (splitstr.length > 0 && validType.includes(ext)) isFileExtensionValid.value = true;
  else {
    isFileExtensionValid.value = false;
    toaster.error(t('CRMSetting.SelectedFileFormat') + " " + `'.${ext}'`+ " " + t('CRMSetting.IsNotAllowed'));
  }
};



const validUploadDocumentSize = (filesize, maxSize) => {
  let maxSizebt = maxSize * 1048576;
  if (filesize <= maxSizebt) {
    isFileValid.value = true;
  } else {
    isFileValid.value = false;
    toaster.error(t('CRMSetting.PleaseUploadAFileOfMaxSize') + " " + `${maxSize}MB.`);
  }
};



const clearSelectedpdf = (element) => {
  element.value = "";
  fileInput.value.nativeElement.value = "";
  fileName.value = "Install Agreement";
};



const prepareFormDataForDocument = (companyId, userId) => {
  let input = new FormData();
  input.append("refid", loanAppId.value);
  input.append("moduleid", "1800");
  input.append("submoduleid", "1810");
  input.append("filetype", "6702E35E-B7B1-4E48-AA98-FF6C012101E1");
  input.append("documentTitle", "InstallAgreement");
  input.append("accountid", accountId.value);
  input.append("CompanyId", companyId);
  input.append("UserId", userId);
  input.append("companyName", companyName.value);
  input.append("fileExtension", fileExtension.value);

  // console.log("fileBrowser", fileInput1.value);
  // const fileBrowser = fileInput1.value.nativeElement;

  // console.log("fileBrowser", fileBrowser);
  if (addSendTLoanHomiForm.value.fileInputValue) {
    input.append("file", addSendTLoanHomiForm.value.fileInputValue);
  }
  console.log("input", input)
  return input;
};



const onChangeLoanProduct = (e) => {
  if (e) {
    addSendTLoanHomiForm.value.term = loanProductList.value.filter(
      (s) => s.value == e
    )[0].name;
  } else {
    addSendTLoanHomiForm.value.term = null;
  }
};



const numberOnly = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode == 46) {
    dotCount.value += 1;
    checkNumberOnly.value = event.target.value;
    var numericCheck = event.target.value.toString();
    if (numericCheck.includes(".")) {
      dotCount.value += 1;
    }
    if (dotCount.value > 1) {
      dotCount.value = 0;
      return false;
    }
  }
  if (charCode > 31 && (charCode <= 45 || charCode > 57 || charCode == 47)) {
    return false;
  }
  checkNumberOnly.value = event.target.value;
  if (checkNumberOnly.value != null) {
    var numeric = event.target.value.toString();
    if (numeric.includes(".")) {
      var checkNumeric = numeric.split(".");
      if (checkNumeric.length > 2) {
        return false;
      }
      checkString.value = checkNumeric[1].split("");
      if (checkString.value.length > 1) {
        return false;
      }
    }
  }
  dotCount.value = 0;
  return true;
};



const keyPressNo = (event) => {
  const pattern = /[0-9\+\ ]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (!pattern.test(inputChar) && event.charCode != "0") {
    event.preventDefault();
  }
};

const onFocusOutEvent = (event) => {
  isInvalidEmail.value = false;
  const pattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  let emailAdd = event.target.value;
  if (emailAdd.match(pattern) != null) {
    // email.value.setValidators([Validators.nullValidator]);
    // email.value.updateValueAndValidity();
  } else {
    // email.value.setValidators([Validators.email]);
    // email.value.updateValueAndValidity();
    isInvalidEmail.value = true;
  }

  if (emailAdd == "") {
    // email.value.setValidators([Validators.required]);
    // email.value.updateValueAndValidity();
  }
};



const onFocusOutEmail = (event) => {
  const pattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  let emailAdd = event.target.value;

  if (emailAdd.match(pattern) != null) {
    // coApp_email.value.setValidators([Validators.nullValidator]);
    // coApp_email.value.updateValueAndValidity();
  } else {
    // coApp_email.value.setValidators([Validators.compose([
    //     Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
    //     Validators.required])
    // ]);
    // coApp_email.value.updateValueAndValidity();
  }
  if (emailAdd == "") {
    // coApp_email.value.setValidators([Validators.required]);
    // coApp_email.value.updateValueAndValidity();
  }
};

// const CheckExistingEmail = (emailAdd) => {
//   opprtunityservice.value.checkExistingEmailAddress(emailAdd).then((result) => {
//     let resultData = JSON.parse(result.result); //convert strint to json//
//     if (resultData) {
//     }
//     if (result.statusCode == 202) {
//       dialogService.value
//         .existingEmail(
//           "Alert",
//           "Contact is already exists with this Email ID. If you click OK then existing contact details will be updated when you submit this form."
//         )
//         .then((confirmed) => {
//           if (emailAdd == resultData.value[0].Email) {
//             if (confirmed) {
//             } else {
//               addSendTLoanHomiForm.value.patchValue({
//                 email: "",
//               });
//             }
//           } else {
//             if (confirmed) {
//             } else {
//               if (resultData.value[0].CoappEmail != null) {
//                 addSendTLoanHomiForm.value.patchValue({
//                   coApp_email: "",
//                 });
//               } else {
//                 addSendTLoanHomiForm.value.patchValue({
//                   coApp_email: "",
//                 });
//               }
//             }
//           }
//         });
//     }
//   });
// };

const termCheck = (event) => {
  Changevalue(event, addSendTLoanHomiForm.isTermCheckBox);
};

const Changevalue = (event, property) => {
  if (event.target.checked == false) {
    property = null;
    // property.setValidators([Validators.required]);
  } else {
    property = true;
    //property.setValidators([Validators.nullValidator]);
  }
  //property.updateValueAndValidity();
};



const borrowersCheck = (event) => {
  Changevalue(event, addSendTLoanHomiForm.isBorrowers);
};



const closeWaringPopup = () => {
  isLoading.value = true;
  //loadSave.value = true;
  //waringPopup.value.hide();
  isshowwarning.value = false;
  showPreviewSendTLoanHomiForm.value = false;
  // addSendTLoanHomiForm.value = null;
  // isAutoPaymentcheckBox.value = true;
  Object.assign(addSendTLoanHomiForm.value, initialState());
  showAddSendTLoanHomiForm.value = true;
  if (fileName.value != "Install Agreement") {
    fileName.value = "Install Agreement";
  }
  isLoading.value = false;
  ////this.loadSave = false;
};



const closeResponsePopup = () => {
  isLoading.value = true;
  //loadSave.value = true;
  //responsePopUp.value.hide();
  isshowresponse.value = false;
  Object.assign(addSendTLoanHomiForm.value, initialState());
  // addSendTLoanHomiForm.value = null;
  // isAutoPaymentcheckBox.value = true;
  showPreviewSendTLoanHomiForm.value = false;
  showAddSendTLoanHomiForm.value = true;

  if (fileName.value != "Install Agreement") {
    fileName.value = "Install Agreement";
  }
  isLoading.value = false;
  // //this.loadSave = false;
};



const clearForm = () => {
  isLoading.value = true;
  //loadSave = true;
  window.scrollTo(0, 0);
  fileInput.value;
  Object.assign(addSendTLoanHomiForm.value, initialState());
  // addSendTLoanHomiForm.value = null;
  // isAutoPaymentcheckBox.value = true;
  if (fileInput.value.nativeElement.value != "") {
    fileInput.value.nativeElement.value = "";
    fileName.value = "Install Agreement";
  }
  isLoading.value = false;
  ////this.loadSave = false;
};



const onFocusOutSSN = (event) => {
  let SSN_No = event.target.value;
  let SSN_NoLength = SSN_No.length;
  if (SSN_No.length < 9) {
    // ssn.value.setValidators([Validators.required]);
    // ssn.value.updateValueAndValidity();
    isSSNValidate.value = true;
  } else {
    // ssn.value.setValidators([Validators.nullValidator]);
    // ssn.value.updateValueAndValidity();
    isSSNValidate.value = false;
  }
};



const removeSpecialCharacters = (event) => {
  var t = event.target.value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "");
  console.log("tttt", t);
  addSendTLoanHomiForm.value.totalSystemCost = t;
};


const removeSpecialCharactersDownpaymentAmount = (event) => {
  var t = event.target.value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "");
  addSendTLoanHomiForm.value.downpaymentAmount = t;
};

///============================= value Change Event =====================================///

const monthsCurrentResidence = (m) => {
  console.log("mmm", m);
  if (m > 11) {
    addSendTLoanHomiForm.value.monthsatCurrentResidence = 11;
  }
};

const monthsCurrentEmployement = (m) => {
  if (m > 11) {
    addSendTLoanHomiForm.value.monthsAtCurrentEmployement = 11;
  }
};

const coApp_monthsCurrentResidence = (m) => {
  if (m > 11) {
    addSendTLoanHomiForm.value.coApp_monthsAtCurrentResidence = 11;
  }
};

const monthsPreviousEmployement = (m) => {
  if (m > 11) {
    addSendTLoanHomiForm.value.monthsAtPreviousEmployement = 11;
  }
};

const coApp_monthsCurrentEmployement = (m) => {
  if (m > 11) {
    addSendTLoanHomiForm.value.coApp_monthsAtCurrentEmployement = 11;
  }
};

const coApp_monthsPreviousEmployement = (m) => {
  if (m > 11) {
    addSendTLoanHomiForm.value.coApp_monthsAtPreviousEmployement = 11;
  }
};

const no_Mortgages = (m) => {
  if (m > 99) {
    addSendTLoanHomiForm.value.noOfMortgages = 99;
  }
};

const employementTypeID = (m) => {
  debugger;
  if (m) {
    let EmpType = lstemployementType.value.filter((n) => n.value == m);
    if (EmpType[0].text == "Employed" || EmpType[0].text == "Self Employed") {
      console.log("if Data");

      // this.yearsAtCurrentEmployement.setValidators([Validators.required]);
      // this.yearsAtCurrentEmployement.updateValueAndValidity();

      // this.monthsAtCurrentEmployement.setValidators([Validators.required]);
      // this.monthsAtCurrentEmployement.updateValueAndValidity();

      // this.occupation.setValidators([Validators.required]);
      // this.occupation.updateValueAndValidity();

      // this.employerName.setValidators([Validators.required]);
      // this.employerName.updateValueAndValidity();
    } else {
      console.log("else");
      // this.yearsAtCurrentEmployement.setValidators([Validators.nullValidator]);
      // this.yearsAtCurrentEmployement.updateValueAndValidity();

      // this.monthsAtCurrentEmployement.setValidators([Validators.nullValidator]);
      // this.monthsAtCurrentEmployement.updateValueAndValidity();

      // this.occupation.setValidators([Validators.nullValidator]);
      // this.occupation.updateValueAndValidity();

      // this.employerName.setValidators([Validators.nullValidator]);
      // this.employerName.updateValueAndValidity();
    }
  }
};



const coApp_employementTypeID = (m) => {
  if (m) {
    let EmpType = lstemployementType.value.filter((n) => n.value == m);
    if (EmpType[0].text == "Employed" || EmpType[0].text == "Self Employed") {
      // this.coApp_yearsAtCurrentEmployement.setValidators([Validators.required]);
      // this.coApp_yearsAtCurrentEmployement.updateValueAndValidity();
      // this.coApp_monthsAtCurrentEmployement.setValidators([Validators.required]);
      // this.coApp_monthsAtCurrentEmployement.updateValueAndValidity();
      // this.coApp_occupation.setValidators([Validators.required]);
      // this.coApp_occupation.updateValueAndValidity();
      // this.coApp_employerName.setValidators([Validators.required]);
      // this.coApp_employerName.updateValueAndValidity();
    } else {
      // this.coApp_yearsAtCurrentEmployement.setValidators([Validators.nullValidator]);
      // this.coApp_yearsAtCurrentEmployement.updateValueAndValidity();
      // this.coApp_monthsAtCurrentEmployement.setValidators([Validators.nullValidator]);
      // this.coApp_monthsAtCurrentEmployement.updateValueAndValidity();
      // this.coApp_occupation.setValidators([Validators.nullValidator]);
      // this.coApp_occupation.updateValueAndValidity();
      // this.coApp_employerName.setValidators([Validators.nullValidator]);
      // this.coApp_employerName.updateValueAndValidity();
    }
  }
};

//==========Validation On Years at Current Residence Fields ================
const yearsAtCurrentResidence = (m) => {
  if (m == "") {
    return;
  }
  if (m == 1 || m == 0) {
    showValidationIconOnPR.value = true;
    // this.yearsAtPreviousResidence.enable();
    // this.monthsatPreviousResidence.enable();
    // this.PRcountry.enable();
    // this.PRstate.enable();
    // this.PRCity.enable();
    // this.PRStreet.enable();
    // this.PRPostalCode.enable();
    // this.PHousingStatus.enable();

    // this.yearsAtPreviousResidence.setValidators([Validators.required]);
    // this.yearsAtPreviousResidence.updateValueAndValidity();

    // this.monthsatPreviousResidence.setValidators([Validators.required]);
    // this.monthsatPreviousResidence.updateValueAndValidity();

    // this.PRcountry.setValidators([Validators.required]);
    // this.PRcountry.updateValueAndValidity();

    // this.PRstate.setValidators([Validators.required]);
    // this.PRstate.updateValueAndValidity();

    // this.PRCity.setValidators([Validators.required]);
    // this.PRCity.updateValueAndValidity();

    // this.PRStreet.setValidators([Validators.required]);
    // this.PRStreet.updateValueAndValidity();

    // this.PRPostalCode.setValidators([Validators.required]);
    // this.PRPostalCode.updateValueAndValidity();

    // this.PHousingStatus.setValidators([Validators.required]);
    // this.PHousingStatus.updateValueAndValidity();
  } else {
    addSendTLoanHomiForm.value.showValidationIconOnPR = false;
    addSendTLoanHomiForm.value.yearsAtPreviousResidence = null;
    addSendTLoanHomiForm.value.monthsatPreviousResidence = null;
    addSendTLoanHomiForm.value.PRcountry = null;
    addSendTLoanHomiForm.value.PRstate = null;
    addSendTLoanHomiForm.value.PRCity = null;
    addSendTLoanHomiForm.value.PRStreet = null;
    addSendTLoanHomiForm.value.PRPostalCode = null;
    addSendTLoanHomiForm.value.PHousingStatus = null;

    // this.yearsAtPreviousResidence.disable();
    // this.monthsatPreviousResidence.disable();
    // this.PRcountry.disable();
    // this.PRstate.disable();
    // this.PRCity.disable();
    // this.PRStreet.disable();
    // this.PRPostalCode.disable();
    // this.PHousingStatus.disable();

    // this.yearsAtPreviousResidence.setValidators([Validators.nullValidator]);
    // this.yearsAtPreviousResidence.updateValueAndValidity();

    // this.monthsatPreviousResidence.setValidators([Validators.nullValidator]);
    // this.monthsatPreviousResidence.updateValueAndValidity();

    // this.PRcountry.setValidators([Validators.nullValidator]);
    // this.PRcountry.updateValueAndValidity();

    // this.PRstate.setValidators([Validators.nullValidator]);
    // this.PRstate.updateValueAndValidity();

    // this.PRCity.setValidators([Validators.nullValidator]);
    // this.PRCity.updateValueAndValidity();

    // this.PRStreet.setValidators([Validators.nullValidator]);
    // this.PRStreet.updateValueAndValidity();

    // this.PRPostalCode.setValidators([Validators.nullValidator]);
    // this.PRPostalCode.updateValueAndValidity();

    // this.PHousingStatus.setValidators([Validators.nullValidator]);
    // this.PHousingStatus.updateValueAndValidity();
  }
};

//============================================================================

//==========Validation On CoApp Years at Current Residence Fields ================

const coApp_yearsAtCurrentResidence = (m) => {
  if (m == "") {
    return;
  }
  if (m == 1 || m == 0) {
    // this.showValidationIconOnCo_PR = true;
    // this.coApp_yearsAtPreviousResidence.enable();
    // this.coApp_monthsatPreviousResidence.enable();
    // this.coApp_PRcountry.enable();
    // this.coApp_PRstate.enable();
    // this.coApp_PRCity.enable();
    // this.coApp_PRStreet.enable();
    // this.coApp_PRPostalCode.enable();
    // this.CoPHousingStatus.enable();
    // this.coApp_yearsAtPreviousResidence.setValidators([Validators.required]);
    // this.coApp_yearsAtPreviousResidence.updateValueAndValidity();
    // this.coApp_monthsatPreviousResidence.setValidators([Validators.required]);
    // this.coApp_monthsatPreviousResidence.updateValueAndValidity();
    // this.coApp_PRcountry.setValidators([Validators.required]);
    // this.coApp_PRcountry.updateValueAndValidity();
    // this.coApp_PRstate.setValidators([Validators.required]);
    // this.coApp_PRstate.updateValueAndValidity();
    // this.coApp_PRCity.setValidators([Validators.required]);
    // this.coApp_PRCity.updateValueAndValidity();
    // this.coApp_PRStreet.setValidators([Validators.required]);
    // this.coApp_PRStreet.updateValueAndValidity();
    // this.coApp_PRPostalCode.setValidators([Validators.required]);
    // this.coApp_PRPostalCode.updateValueAndValidity();
    // this.CoPHousingStatus.setValidators([Validators.required]);
    // this.CoPHousingStatus.updateValueAndValidity();
  } else {
    addSendTLoanHomiForm.value.showValidationIconOnCo_PR = false;
    addSendTLoanHomiForm.value.coApp_yearsAtPreviousResidence = null;
    addSendTLoanHomiForm.value.coApp_monthsatPreviousResidence = null;
    addSendTLoanHomiForm.value.coApp_PRcountry = null;
    addSendTLoanHomiForm.value.coApp_PRstate = null;
    addSendTLoanHomiForm.value.coApp_PRCity = null;
    addSendTLoanHomiForm.value.coApp_PRStreet = null;
    addSendTLoanHomiForm.value.coApp_PRPostalCode = null;
    addSendTLoanHomiForm.value.CoPHousingStatus = null;

    // this.coApp_yearsAtPreviousResidence.disable();
    // this.coApp_monthsatPreviousResidence.disable();
    // this.coApp_PRcountry.disable();
    // this.coApp_PRstate.disable();
    // this.coApp_PRCity.disable();
    // this.coApp_PRStreet.disable();
    // this.coApp_PRPostalCode.disable();
    // this.CoPHousingStatus.disable();

    // this.coApp_yearsAtPreviousResidence.setValidators([Validators.nullValidator]);
    // this.coApp_yearsAtPreviousResidence.updateValueAndValidity();

    // this.coApp_monthsatPreviousResidence.setValidators([Validators.nullValidator]);
    // this.coApp_monthsatPreviousResidence.updateValueAndValidity();

    // this.coApp_PRcountry.setValidators([Validators.nullValidator]);
    // this.coApp_PRcountry.updateValueAndValidity();

    // this.coApp_PRstate.setValidators([Validators.nullValidator]);
    // this.coApp_PRstate.updateValueAndValidity();

    // this.coApp_PRCity.setValidators([Validators.nullValidator]);
    // this.coApp_PRCity.updateValueAndValidity();

    // this.coApp_PRStreet.setValidators([Validators.nullValidator]);
    // this.coApp_PRStreet.updateValueAndValidity();

    // this.coApp_PRPostalCode.setValidators([Validators.nullValidator]);
    // this.coApp_PRPostalCode.updateValueAndValidity();

    // this.CoPHousingStatus.setValidators([Validators.nullValidator]);
    // this.CoPHousingStatus.updateValueAndValidity();
  }
};
//============================================================================

//==========Validation On Years at Current Employement Fields ================
const yearsAtCurrentEmployement = (m) => {
  if (m == "") {
    return;
  }
  if (m == 1 || m == 0) {
    sendToLoanHomiDataModel.value.IsOE = true;
    // this.ShowPreviousEmployerDetails = true;

    // this.previousEmployerName.enable();
    // this.previousOccupation.enable();
    // this.yearsAtPreviousEmployement.enable();
    // this.monthsAtPreviousEmployement.enable();
    // this.previousEmployerName.setValidators([Validators.required]);
    // this.previousEmployerName.updateValueAndValidity();

    // this.previousOccupation.setValidators([Validators.required]);
    // this.previousOccupation.updateValueAndValidity();

    // this.yearsAtPreviousEmployement.setValidators([Validators.required]);
    // this.yearsAtPreviousEmployement.updateValueAndValidity();

    // this.monthsAtPreviousEmployement.setValidators([Validators.required]);
    // this.monthsAtPreviousEmployement.updateValueAndValidity();
  } else {
    // this.ShowPreviousEmployerDetails = false;
    sendToLoanHomiDataModel.value.IsOE = false;

    // this.previousEmployerName.disable();
    // this.previousOccupation.disable();
    // this.yearsAtPreviousEmployement.disable();
    // this.monthsAtPreviousEmployement.disable();

    // this.previousEmployerName.setValue(null);
    // this.previousEmployerName.setValidators([Validators.nullValidator]);
    // this.previousEmployerName.updateValueAndValidity();

    // this.previousOccupation.setValue(null);
    // this.previousOccupation.setValidators([Validators.nullValidator]);
    // this.previousOccupation.updateValueAndValidity();

    // this.yearsAtPreviousEmployement.setValue(null);
    // this.yearsAtPreviousEmployement.setValidators([Validators.nullValidator]);
    // this.yearsAtPreviousEmployement.updateValueAndValidity();

    // this.monthsAtPreviousEmployement.setValue(null);
    // this.monthsAtPreviousEmployement.setValidators([Validators.nullValidator]);
    // this.monthsAtPreviousEmployement.updateValueAndValidity();
  }
};
//============================================================================

//============ Validation on Is co-applicant required Fields =================
const IsCoApplicantRequired = () => {
  if (addSendTLoanHomiForm.value.IsCoApplicantRequired == true) {
  } else {
    addSendTLoanHomiForm.value.sameAsapplicant = false;
    addSendTLoanHomiForm.value.coApp_firstName = null;
    addSendTLoanHomiForm.value.coApp_lastName = null;
    addSendTLoanHomiForm.value.coApp_email = null;
    addSendTLoanHomiForm.value.coApp_ssn = null;
    addSendTLoanHomiForm.value.CoHousingStatus = null;
    addSendTLoanHomiForm.value.coApp_dateofBirth = null;
    addSendTLoanHomiForm.value.coApp_country = null;
    addSendTLoanHomiForm.value.coAppstate = null;
    addSendTLoanHomiForm.value.coApp_city = null;
    addSendTLoanHomiForm.value.coApp_street = null;
    addSendTLoanHomiForm.value.coApp_occupation = null;
    addSendTLoanHomiForm.value.coApp_yearsAtCurrentEmployement = null;
    addSendTLoanHomiForm.value.coApp_monthsAtCurrentEmployement = null;
    addSendTLoanHomiForm.value.coApp_employerName = null;
    addSendTLoanHomiForm.value.coApp_incomeFrequency = null;
    addSendTLoanHomiForm.value.coApp_income = null;
    addSendTLoanHomiForm.value.coApp_employementTypeID = null;
    addSendTLoanHomiForm.value.coApp_previousEmployerName = null;
    addSendTLoanHomiForm.value.coApp_previousOccupation = null;
    addSendTLoanHomiForm.value.coApp_yearsAtCurrentResidence = null;
    addSendTLoanHomiForm.value.coApp_monthsAtCurrentResidence = null;
    addSendTLoanHomiForm.value.coApp_yearsAtPreviousEmployement = null;
    addSendTLoanHomiForm.value.coApp_monthsAtPreviousEmployement = null;
    addSendTLoanHomiForm.value.coApp_phone = null;
    addSendTLoanHomiForm.value.coApp_mobile = null;
    addSendTLoanHomiForm.value.coApp_postalCode = null;
    addSendTLoanHomiForm.value.coApp_otherIncomeFrequency = null;
    addSendTLoanHomiForm.value.coApp_otherIncome = null;
    addSendTLoanHomiForm.value.coApp_otherIncomeSource = null;
    addSendTLoanHomiForm.value.coApp_grossIncome = null;
    addSendTLoanHomiForm.value.coApp_yearsAtPreviousResidence = null;
    addSendTLoanHomiForm.value.coApp_monthsatPreviousResidence = null;
    addSendTLoanHomiForm.value.coApp_PRcountry = null;
    addSendTLoanHomiForm.value.coApp_PRstate = null;
    addSendTLoanHomiForm.value.coApp_PRCity = null;
    addSendTLoanHomiForm.value.coApp_PRStreet = null;
    addSendTLoanHomiForm.value.coApp_PRPostalCode = null;
    addSendTLoanHomiForm.value.CoPHousingStatus = null;
  }
};

//============================================================================
//============== Validate On coApp_yearsAtCurrentEmployement Field ==========
const coApp_yearsAtCurrentEmployement = (m) => {
  if (m == 1) {
    sendToLoanHomiDataModel.value.coIsOE = true;

    // this.coApp_previousEmployerName.enable();
    // this.coApp_previousOccupation.enable();
    // this.coApp_yearsAtPreviousEmployement.enable();
    // this.coApp_monthsAtPreviousEmployement.enable();

    // this.coApp_previousEmployerName.setValidators([Validators.required]);
    // this.coApp_previousEmployerName.updateValueAndValidity();

    // this.coApp_previousOccupation.setValidators([Validators.required]);
    // this.coApp_previousOccupation.updateValueAndValidity();

    // this.coApp_yearsAtPreviousEmployement.setValidators([Validators.required]);
    // this.coApp_yearsAtPreviousEmployement.updateValueAndValidity();

    // this.coApp_monthsAtPreviousEmployement.setValidators([Validators.required]);
    // this.coApp_monthsAtPreviousEmployement.updateValueAndValidity();
  } else {
    // this.coApp_previousEmployerName.disable();
    // this.coApp_previousOccupation.disable();
    // this.coApp_yearsAtPreviousEmployement.disable();
    // this.coApp_monthsAtPreviousEmployement.disable();

    sendToLoanHomiDataModel.value.coIsOE = false;
    addSendTLoanHomiForm.value.coApp_previousEmployerName = null;
    // this.coApp_previousEmployerName.setValidators([Validators.nullValidator]);
    // this.coApp_previousEmployerName.updateValueAndValidity();

    addSendTLoanHomiForm.value.coApp_previousOccupation = null;
    // this.coApp_previousOccupation.setValidators([Validators.nullValidator]);
    // this.coApp_previousOccupation.updateValueAndValidity();

    addSendTLoanHomiForm.value.coApp_yearsAtPreviousEmployement = null;
    // this.coApp_yearsAtPreviousEmployement.setValidators([Validators.nullValidator]);
    // this.coApp_yearsAtPreviousEmployement.updateValueAndValidity();

    addSendTLoanHomiForm.value.coApp_monthsAtPreviousEmployement = null;
    // this.coApp_monthsAtPreviousEmployement.setValidators([Validators.nullValidator]);
    // this.coApp_monthsAtPreviousEmployement.updateValueAndValidity();
  }
};

//============================================================================

const sameAsapplicant = (m) => {
  console.log("m", m);
  if (m == true) {
    if (
      typeof addSendTLoanHomiForm.value.country !== "undefined" &&
      addSendTLoanHomiForm.value.country !== null
    ) {
      getStatesByCountry(addSendTLoanHomiForm.value.country, "third");
    }
    addSendTLoanHomiForm.value.coApp_country = addSendTLoanHomiForm.value.country;
    addSendTLoanHomiForm.value.coAppstate = addSendTLoanHomiForm.value.state;
    addSendTLoanHomiForm.value.coApp_city = addSendTLoanHomiForm.value.city;
    addSendTLoanHomiForm.value.coApp_street = addSendTLoanHomiForm.value.street;
    addSendTLoanHomiForm.value.coApp_postalCode = addSendTLoanHomiForm.value.postalCode;
  } else {
    addSendTLoanHomiForm.value.coApp_country = null;
    addSendTLoanHomiForm.value.coAppstate = null;
    addSendTLoanHomiForm.value.coApp_city = null;
    addSendTLoanHomiForm.value.coApp_street = null;
    addSendTLoanHomiForm.value.coApp_postalCode = null;
  }
};

const totalSystemCost = (m) => {
  if (m < 0) {
    event.preventDefault();
    addSendTLoanHomiForm.value.totalSystemCost = 0;
    return;
  }

  tscAmtValidation.value = false;
  let totalSysCost;
  totalSysCost = Number(m);

  addSendTLoanHomiForm.value.downpaymentAmount = null;
  addSendTLoanHomiForm.value.loanAmount =
    totalSysCost - addSendTLoanHomiForm.value.downpaymentAmount;

  TotalloanAmount.value = Number(m);
};

const downpaymentAmount = (m) => {
  console.log("DownPaymentAmount", m);
  dpAmtValidation.value = false;
  m = Number(m);
  if (m < 0) {
    event.preventDefault();
    addSendTLoanHomiForm.value.downpaymentAmount = 0;
    return;
  }
  if (m > Number(addSendTLoanHomiForm.value.totalSystemCost)) {
    addSendTLoanHomiForm.value.downpaymentAmount = null;
    dpAmtValidation.value = true;
    return;
  }

  addSendTLoanHomiForm.value.downpaymentAmount = Number(m);

  if (addSendTLoanHomiForm.value.downpaymentAmount > TotalloanAmount.value) {
    addSendTLoanHomiForm.value.loanAmount = 0;
    addSendTLoanHomiForm.value.downpaymentAmount = TotalloanAmount.value;
    event.preventDefault();
  } else {
    totalLoanAmt.value =
      Number(addSendTLoanHomiForm.value.totalSystemCost) -
      addSendTLoanHomiForm.value.downpaymentAmount;
    result.value = totalLoanAmt.value;
    let re = /\,/gi;

    console.log("totalLoanAmt.value", totalLoanAmt.value);
    if (result.value != null) {
      //result.value = result.value.replace(re, "");
      addSendTLoanHomiForm.value.loanAmount = result.value;
    }
  }
};

//----Calculating Applicant Gross Amt-------------

const lstIncomeFrequencyID = (m) => {
  incomedisable.value = false;
  totalGrossAmt.value = 0;
  if (m == iFreqMonthValue.value) {
    //this.ShowIncomeFrequency = true;
    showValidationIconOn_income.value = true;
    //income.value.enable();
    incomeType.value = m;
    totalGrossAmt.value = income.value * 12;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  } else if (m == iFreqYearValue.value) {
    // this.ShowIncomeFrequency = true;
    showValidationIconOn_income.value = true;
    //income.value.enable();
    incomeType.value = m;
    totalGrossAmt.value = income.value;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  }
  if (m != iFreqMonthValue.value && m != iFreqYearValue.value) {
    incomeType.value = null;
    totalGrossAmt.value = 0;

    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
    income.value = 0;
    //this.ShowIncomeFrequency = false;
    //income.value.disable();
    showValidationIconOn_income.value = false;
  }
};

const income = (m) => {
  if (m < 0) {
    event.preventDefault();
    income.value = 0;
    return;
  }

  // 1146 --Monthly Id
  if (incomeType.value == iFreqMonthValue.value) {
    totalGrossAmt.value = m * 12;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  } else if (incomeType.value == iFreqYearValue.value) {
    totalGrossAmt.value = m;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  }
  if (m == null) {
    totalGrossAmt.value = 0;
  }
};

const otherIncomeFrequencyID = (m) => {
  if (m == null) {
    otherIncomedisable.value = true;
  }

  totalOtherFreqIncome.value = 0;
  if (m == iFreqMonthValue.value) {
    otherIncomedisable.value = false;
    // this.ShowotherIncomeFrequency = true;
    //otherIncome.value.enable();
    otherIncomeType.value = m;
    totalOtherFreqIncome.value = addSendTLoanHomiForm.value.otherIncome * 12;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  } else if (m == iFreqYearValue.value) {
    otherIncomedisable.value = false;
    //this.ShowotherIncomeFrequency = true;
    //otherIncome.value.enable();
    otherIncomeType.value = m;
    totalOtherFreqIncome.value = addSendTLoanHomiForm.otherIncome;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  }
  if (m != iFreqMonthValue.value && m != iFreqYearValue.value) {
    otherIncomedisable.value = false;
    //this.ShowotherIncomeFrequency = false;
    //otherIncome.value.disable();
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
    otherIncome.value = 0;
  }
};

const otherIncome = (m) => {
  if (m < 0) {
    event.preventDefault();
    otherIncome.value = 0;
    return;
  }
  totalOtherFreqIncome.value = 0;
  // 1146 --Monthly Id
  if (otherIncomeType.value == iFreqMonthValue.value) {
    totalOtherFreqIncome.value = m * 12;
    addSendTLoanHomiForm.value.grossIncome =
      totalGrossAmt.value + totalOtherFreqIncome.value;
  } else if (otherIncomeType.value == iFreqYearValue.value) {
    totalOtherFreqIncome.value = m;
    addSendTLoanHomiForm.value.grossIncome = totalGrossAmt.value + m;
  }
};

// //----------------------------------------

// //----Calculating Co-Applicant Gross Amt-------------

const coApp_incomeFrequency = (m) => {
  if (m == iFreqMonthValue.value) {
    //this.show_CoApp_IncomeFrequency = true;
    //addSendTLoanHomiForm.value.coApp_income.enable();
    showValidationIconOn_coApp_income.value = true;

    coApp_incomeType.value = m;
    totalCo_App_GrossAmt.value = addSendTLoanHomiForm.value.coApp_income * 12;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  } else if (m == iFreqYearValue.value) {
    //this.show_CoApp_IncomeFrequency = true;
    //addSendTLoanHomiForm.value.coApp_income.enable();
    showValidationIconOn_coApp_income.value = true;

    coApp_incomeType.value = m;
    totalCo_App_GrossAmt.value = addSendTLoanHomiForm.value.coApp_income;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  }
  if (m != iFreqMonthValue.value && m != iFreqYearValue.value) {
    coApp_otherIncomeType.value = null;
    totalCo_App_GrossAmt.value = 0;

    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
    addSendTLoanHomiForm.value.coApp_income = 0;
    //this.show_CoApp_IncomeFrequency = false;
    //addSendTLoanHomiForm.value.coApp_income.disable();
    showValidationIconOn_coApp_income.value = false;
  }
};

const coApp_income = (m) => {
  console.log("income-m", m);
  if (m < 0) {
    event.preventDefault();
    addSendTLoanHomiForm.value.coApp_income = 0;
    return;
  }
  // 1146 --Monthly Id
  if (coApp_incomeType.value == iFreqMonthValue.value) {
    totalCo_App_GrossAmt.value = m * 12;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  } else if (coApp_incomeType.value == iFreqYearValue.value) {
    totalCo_App_GrossAmt.value = m;
    var data = m + Co_App_totalOtherFreqIncome.value;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;

    if (m == null) {
      totalCo_App_GrossAmt.value = 0;
    }
  }
};

const coApp_otherIncomeFrequency = (m) => {
  Co_App_totalOtherFreqIncome.value = 0;
  if (m == iFreqMonthValue.value) {
    //this.show_CoApp_otherIncomeFrequency = true;
    //coApp_otherIncome.value.enable();
    coApp_otherIncomeType.value = m;
    Co_App_totalOtherFreqIncome.value = coApp_otherIncome.value * 12;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  } else if (m == iFreqYearValue.value) {
    //this.show_CoApp_otherIncomeFrequency = true;
    //coApp_otherIncome.value.enable();
    coApp_otherIncomeType.value = m;
    Co_App_totalOtherFreqIncome.value = coApp_otherIncome.value;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  }
  if (m != iFreqMonthValue.value && m != iFreqYearValue.value) {
    //this.show_CoApp_otherIncomeFrequency = false;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
    addSendTLoanHomiForm.value.coApp_otherIncome.value = 0;
    //coApp_otherIncome.value.disable();
  }
};

const coApp_otherIncome = (m) => {
  if (m < 0) {
    event.preventDefault();
    addSendTLoanHomiForm.value.coApp_otherIncome = 0;
    return;
  }
  // 1440 --Monthly Id
  Co_App_totalOtherFreqIncome.value = 0;
  if (coApp_otherIncomeType.value == iFreqMonthValue.value) {
    Co_App_totalOtherFreqIncome.value = m * 12;
    addSendTLoanHomiForm.value.coApp_grossIncome =
      totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
  } else {
    if (coApp_otherIncomeType.value == iFreqYearValue.value) {
      Co_App_totalOtherFreqIncome.value = m;
      addSendTLoanHomiForm.value.coApp_grossIncome =
        totalCo_App_GrossAmt.value + Co_App_totalOtherFreqIncome.value;
    }
  }
};

onMounted(() => {
  getUserInfo();
  localStorage.setItem("isStandalone", "true");

  setTimeout(() => {
    if (route.params) {
      const id = route.params.id;
      const companyIds = route.params.companyId;
      const accountId = route.params.accountId;
      const userIds = route.params.userId;
      if (companyIds) {
        dealerCompanyId.value = companyIds;
        companyId.value = companyIds;
      }
      if (accountId) {
        dealerAccountId.value = accountId;
      }
      if (id) {
        dealerName.value = id;
      }
      if (userIds) {
        userId.value = userIds;
      }
      console.log("userIds", userIds);

      getConfigurationTypeFileExtensions();
      totalGrossAmt.value = 0;
      GetOwnThePropertyDll();
      GetPrevHousingStatus();
      GetCurrendHousingStatus();
      GetEmployementTypeDll();
      GetIncomeFrequencyDll();
      getCountryDropdownList();
      //this.getState();
      getLoanProductList();
      getInstallerRepNameList();
      getcompanyName(dealerCompanyId.value);
      getAccountNameById();
    }
  }, 3000);
});

//----------------------------------------
</script>

<style>
.standalone-dealer {
  text-align: right !important;
  max-width: 1010px;
  margin: 0px auto;
  margin-top: -30px;
  font-size: large;
  font-weight: 900;
}

.form-group small {
  margin-top: 0px !important;
  display: block;
  margin-bottom: 10px;
}

.standalone-page form,
.standalone-page-container {
  max-width: 1010px;
  background: #fff;
  padding: 20px;
  margin: 0 auto 50px;
  box-shadow: 0 0 5px 0 #d0d0d0;
}

.loader-popup {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.5);
}

.loader-popup app-loader-white {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

img {
  vertical-align: middle;
  border-style: none;
}

.standalone-header {
  background: #b49859;
  padding: 10px;
  margin-bottom: 20px;
}

.standalone-header .standalone-logo {
  max-width: 1010px;
  margin: 0 auto;
}

.main-content {
  background: #f5f5f5;
  margin-left: 0;
  min-height: 100px;
  overflow: auto;
  width: 100%;
}

.input-group-prepend .input-group-text {
  color: #fff;
  background-color: #2a7cf9;
  border: 1px solid #2b7dfa;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.form-control {
  border-radius: 2px !important;
  border: 1px solid #c1c1c1;
  font-size: 0.875rem;
  color: #4d5875;
  height: calc(1.5em + 0.75rem + 4px);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input-group-append,
.input-group-prepend {
  display: flex;
}

.input-group-prepend {
  margin-right: -1px;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
  left: 0;
}

.custom-control-label {
  cursor: pointer;
  position: unset;
  margin-bottom: 0;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-control-label::before {
  background-color: #fdfefe;
  border: 1px solid #9c9c9c;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.custom-control-label::after {
  top: -1px;
  width: 20px;
  height: 26px;
  left: -1px;
}

.custom-control-label::after {
  position: absolute;
  display: block;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

/* Before check styling */

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-control-label::before {
  background-color: #fdfefe;
  border: 1px solid #9c9c9c;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.custom-control-label {
  cursor: pointer;
  position: unset;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-control-label::before {
  background-color: #fdfefe;
  border: 1px solid #9c9c9c;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.custom-control-label {
  cursor: pointer;
  position: unset;
}

/* After check styling */

.custom-control-label::after {
  top: -1px;
  width: 20px;
  height: 26px;
  left: -1px;
}

.custom-control-label::after {
  position: absolute;
  display: block;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-control-label {
  cursor: pointer;
  position: unset;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}

.custom-control-input.is-invalid~.custom-control-label::before,
.was-validated .custom-control-input:invalid~.custom-control-label::before {
  border-color: #dc3545;
}

.custom-control-input.is-invalid~.custom-control-label::before,
.was-validated .custom-control-input:invalid~.custom-control-label::before {
  background-color: #efa2a9;
}

.custom-control-input.is-invalid~.custom-control-label,
.was-validated .custom-control-input:invalid~.custom-control-label {
  color: #dc3545;
}

.custom-control-label {
  cursor: pointer;
  position: unset;
}

.custom-control-label::after {
  top: -1px;
  width: 20px;
  height: 26px;
  left: -1px;
}

.custom-control-label::after {
  position: absolute;
  display: block;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-control-input.is-invalid~.custom-control-label,
.was-validated .custom-control-input:invalid~.custom-control-label {
  color: #dc3545;
}

</style>
